import { O as ca, aB as kt, aF as la, T as xe, aG as wn, a6 as ct, f as z, aH as $r, d as Oe, ad as ua, G as lt, ae as ut, ab as ot, a8 as da, ac as fa, aI as Vr, aD as ma, aJ as ga, k as un, _ as ae, aK as va, e as De, h as le, i as ke, R as pa, q as it, C as Ur, D as Wr, o as zr, n as Br, L as nr, m as hn, c as ha, K as tr, aL as ba, I as ya } from "./country-de01c755.js";
import * as S from "react";
import ne, { createContext as _t, useContext as en, useEffect as Je, useRef as Ge, useLayoutEffect as wa, useState as rr } from "react";
var Hr = {}, Sa = (e) => encodeURIComponent(e).replace(/[!'()*]/g, (n) => `%${n.charCodeAt(0).toString(16).toUpperCase()}`), Kr = "%[a-f0-9]{2}", or = new RegExp("(" + Kr + ")|([^%]+?)", "gi"), ir = new RegExp("(" + Kr + ")+", "gi");
function dt(e, n) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  n = n || 1;
  var t = e.slice(0, n), r = e.slice(n);
  return Array.prototype.concat.call([], dt(t), dt(r));
}
function Ea(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    for (var n = e.match(or) || [], t = 1; t < n.length; t++)
      e = dt(n, t).join(""), n = e.match(or) || [];
    return e;
  }
}
function Ca(e) {
  for (var n = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  }, t = ir.exec(e); t; ) {
    try {
      n[t[0]] = decodeURIComponent(t[0]);
    } catch {
      var r = Ea(t[0]);
      r !== t[0] && (n[t[0]] = r);
    }
    t = ir.exec(e);
  }
  n["%C2"] = "�";
  for (var o = Object.keys(n), i = 0; i < o.length; i++) {
    var a = o[i];
    e = e.replace(new RegExp(a, "g"), n[a]);
  }
  return e;
}
var xa = function(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return e = e.replace(/\+/g, " "), decodeURIComponent(e);
  } catch {
    return Ca(e);
  }
}, Oa = (e, n) => {
  if (!(typeof e == "string" && typeof n == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (n === "")
    return [e];
  const t = e.indexOf(n);
  return t === -1 ? [e] : [
    e.slice(0, t),
    e.slice(t + n.length)
  ];
}, Ta = function(e, n) {
  for (var t = {}, r = Object.keys(e), o = Array.isArray(n), i = 0; i < r.length; i++) {
    var a = r[i], d = e[a];
    (o ? n.indexOf(a) !== -1 : n(a, d, e)) && (t[a] = d);
  }
  return t;
};
(function(e) {
  const n = Sa, t = xa, r = Oa, o = Ta, i = (m) => m == null, a = Symbol("encodeFragmentIdentifier");
  function d(m) {
    switch (m.arrayFormat) {
      case "index":
        return (f) => (v, w) => {
          const E = v.length;
          return w === void 0 || m.skipNull && w === null || m.skipEmptyString && w === "" ? v : w === null ? [...v, [p(f, m), "[", E, "]"].join("")] : [
            ...v,
            [p(f, m), "[", p(E, m), "]=", p(w, m)].join("")
          ];
        };
      case "bracket":
        return (f) => (v, w) => w === void 0 || m.skipNull && w === null || m.skipEmptyString && w === "" ? v : w === null ? [...v, [p(f, m), "[]"].join("")] : [...v, [p(f, m), "[]=", p(w, m)].join("")];
      case "colon-list-separator":
        return (f) => (v, w) => w === void 0 || m.skipNull && w === null || m.skipEmptyString && w === "" ? v : w === null ? [...v, [p(f, m), ":list="].join("")] : [...v, [p(f, m), ":list=", p(w, m)].join("")];
      case "comma":
      case "separator":
      case "bracket-separator": {
        const f = m.arrayFormat === "bracket-separator" ? "[]=" : "=";
        return (v) => (w, E) => E === void 0 || m.skipNull && E === null || m.skipEmptyString && E === "" ? w : (E = E === null ? "" : E, w.length === 0 ? [[p(v, m), f, p(E, m)].join("")] : [[w, p(E, m)].join(m.arrayFormatSeparator)]);
      }
      default:
        return (f) => (v, w) => w === void 0 || m.skipNull && w === null || m.skipEmptyString && w === "" ? v : w === null ? [...v, p(f, m)] : [...v, [p(f, m), "=", p(w, m)].join("")];
    }
  }
  function h(m) {
    let f;
    switch (m.arrayFormat) {
      case "index":
        return (v, w, E) => {
          if (f = /\[(\d*)\]$/.exec(v), v = v.replace(/\[\d*\]$/, ""), !f) {
            E[v] = w;
            return;
          }
          E[v] === void 0 && (E[v] = {}), E[v][f[1]] = w;
        };
      case "bracket":
        return (v, w, E) => {
          if (f = /(\[\])$/.exec(v), v = v.replace(/\[\]$/, ""), !f) {
            E[v] = w;
            return;
          }
          if (E[v] === void 0) {
            E[v] = [w];
            return;
          }
          E[v] = [].concat(E[v], w);
        };
      case "colon-list-separator":
        return (v, w, E) => {
          if (f = /(:list)$/.exec(v), v = v.replace(/:list$/, ""), !f) {
            E[v] = w;
            return;
          }
          if (E[v] === void 0) {
            E[v] = [w];
            return;
          }
          E[v] = [].concat(E[v], w);
        };
      case "comma":
      case "separator":
        return (v, w, E) => {
          const P = typeof w == "string" && w.includes(m.arrayFormatSeparator), T = typeof w == "string" && !P && y(w, m).includes(m.arrayFormatSeparator);
          w = T ? y(w, m) : w;
          const N = P || T ? w.split(m.arrayFormatSeparator).map((L) => y(L, m)) : w === null ? w : y(w, m);
          E[v] = N;
        };
      case "bracket-separator":
        return (v, w, E) => {
          const P = /(\[\])$/.test(v);
          if (v = v.replace(/\[\]$/, ""), !P) {
            E[v] = w && y(w, m);
            return;
          }
          const T = w === null ? [] : w.split(m.arrayFormatSeparator).map((N) => y(N, m));
          if (E[v] === void 0) {
            E[v] = T;
            return;
          }
          E[v] = [].concat(E[v], T);
        };
      default:
        return (v, w, E) => {
          if (E[v] === void 0) {
            E[v] = w;
            return;
          }
          E[v] = [].concat(E[v], w);
        };
    }
  }
  function c(m) {
    if (typeof m != "string" || m.length !== 1)
      throw new TypeError("arrayFormatSeparator must be single character string");
  }
  function p(m, f) {
    return f.encode ? f.strict ? n(m) : encodeURIComponent(m) : m;
  }
  function y(m, f) {
    return f.decode ? t(m) : m;
  }
  function s(m) {
    return Array.isArray(m) ? m.sort() : typeof m == "object" ? s(Object.keys(m)).sort((f, v) => Number(f) - Number(v)).map((f) => m[f]) : m;
  }
  function u(m) {
    const f = m.indexOf("#");
    return f !== -1 && (m = m.slice(0, f)), m;
  }
  function l(m) {
    let f = "";
    const v = m.indexOf("#");
    return v !== -1 && (f = m.slice(v)), f;
  }
  function g(m) {
    m = u(m);
    const f = m.indexOf("?");
    return f === -1 ? "" : m.slice(f + 1);
  }
  function b(m, f) {
    return f.parseNumbers && !Number.isNaN(Number(m)) && typeof m == "string" && m.trim() !== "" ? m = Number(m) : f.parseBooleans && m !== null && (m.toLowerCase() === "true" || m.toLowerCase() === "false") && (m = m.toLowerCase() === "true"), m;
  }
  function _(m, f) {
    f = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ",",
      parseNumbers: !1,
      parseBooleans: !1
    }, f), c(f.arrayFormatSeparator);
    const v = h(f), w = /* @__PURE__ */ Object.create(null);
    if (typeof m != "string" || (m = m.trim().replace(/^[?#&]/, ""), !m))
      return w;
    for (const E of m.split("&")) {
      if (E === "")
        continue;
      let [P, T] = r(f.decode ? E.replace(/\+/g, " ") : E, "=");
      T = T === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(f.arrayFormat) ? T : y(T, f), v(y(P, f), T, w);
    }
    for (const E of Object.keys(w)) {
      const P = w[E];
      if (typeof P == "object" && P !== null)
        for (const T of Object.keys(P))
          P[T] = b(P[T], f);
      else
        w[E] = b(P, f);
    }
    return f.sort === !1 ? w : (f.sort === !0 ? Object.keys(w).sort() : Object.keys(w).sort(f.sort)).reduce((E, P) => {
      const T = w[P];
      return T && typeof T == "object" && !Array.isArray(T) ? E[P] = s(T) : E[P] = T, E;
    }, /* @__PURE__ */ Object.create(null));
  }
  e.extract = g, e.parse = _, e.stringify = (m, f) => {
    if (!m)
      return "";
    f = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none",
      arrayFormatSeparator: ","
    }, f), c(f.arrayFormatSeparator);
    const v = (T) => f.skipNull && i(m[T]) || f.skipEmptyString && m[T] === "", w = d(f), E = {};
    for (const T of Object.keys(m))
      v(T) || (E[T] = m[T]);
    const P = Object.keys(E);
    return f.sort !== !1 && P.sort(f.sort), P.map((T) => {
      const N = m[T];
      return N === void 0 ? "" : N === null ? p(T, f) : Array.isArray(N) ? N.length === 0 && f.arrayFormat === "bracket-separator" ? p(T, f) + "[]" : N.reduce(w(T), []).join("&") : p(T, f) + "=" + p(N, f);
    }).filter((T) => T.length > 0).join("&");
  }, e.parseUrl = (m, f) => {
    f = Object.assign({
      decode: !0
    }, f);
    const [v, w] = r(m, "#");
    return Object.assign(
      {
        url: v.split("?")[0] || "",
        query: _(g(m), f)
      },
      f && f.parseFragmentIdentifier && w ? { fragmentIdentifier: y(w, f) } : {}
    );
  }, e.stringifyUrl = (m, f) => {
    f = Object.assign({
      encode: !0,
      strict: !0,
      [a]: !0
    }, f);
    const v = u(m.url).split("?")[0] || "", w = e.extract(m.url), E = e.parse(w, { sort: !1 }), P = Object.assign(E, m.query);
    let T = e.stringify(P, f);
    T && (T = `?${T}`);
    let N = l(m.url);
    return m.fragmentIdentifier && (N = `#${f[a] ? p(m.fragmentIdentifier, f) : m.fragmentIdentifier}`), `${v}${T}${N}`;
  }, e.pick = (m, f, v) => {
    v = Object.assign({
      parseFragmentIdentifier: !0,
      [a]: !1
    }, v);
    const { url: w, query: E, fragmentIdentifier: P } = e.parseUrl(m, v);
    return e.stringifyUrl({
      url: w,
      query: o(E, f),
      fragmentIdentifier: P
    }, v);
  }, e.exclude = (m, f, v) => {
    const w = Array.isArray(f) ? (E) => !f.includes(E) : (E, P) => !f(E, P);
    return e.pick(m, w, v);
  };
})(Hr);
const Fd = /* @__PURE__ */ ca(Hr);
function ft(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Pa(e) {
  if (Array.isArray(e))
    return ft(e);
}
function Na(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function Ma(e, n) {
  if (e) {
    if (typeof e == "string")
      return ft(e, n);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ft(e, n) : void 0;
  }
}
function Aa() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ia(e) {
  return Pa(e) || Na(e) || Ma(e) || Aa();
}
var ka = /* @__PURE__ */ _t({});
const Lt = ka;
function Gr() {
}
let Ke = null;
function _a() {
  Ke = null, la();
}
let Ft = Gr;
process.env.NODE_ENV !== "production" && (Ft = (e, n, t) => {
  kt(e, `[antd: ${n}] ${t}`), process.env.NODE_ENV === "test" && _a();
});
const Xr = /* @__PURE__ */ S.createContext({}), Tn = process.env.NODE_ENV !== "production" ? (e) => {
  const {
    strict: n
  } = S.useContext(Xr), t = (r, o, i) => {
    if (!r)
      if (n === !1 && o === "deprecated") {
        const a = Ke;
        Ke || (Ke = {}), Ke[e] = Ke[e] || [], Ke[e].includes(i || "") || Ke[e].push(i || "");
      } else
        process.env.NODE_ENV !== "production" && Ft(r, e, i);
  };
  return t.deprecated = (r, o, i, a) => {
    t(r, "deprecated", `\`${o}\` is deprecated. Please use \`${i}\` instead.${a ? ` ${a}` : ""}`);
  }, t;
} : () => {
  const e = () => {
  };
  return e.deprecated = Gr, e;
}, Gn = Ft, La = /* @__PURE__ */ _t(void 0);
var Fa = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
}, Ra = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: !0,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
const ja = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
}, Yr = ja, Da = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, Ra),
  timePickerLocale: Object.assign({}, Yr)
}, ar = Da, Ce = "${label} is not a valid ${type}", $a = {
  locale: "en",
  Pagination: Fa,
  DatePicker: ar,
  TimePicker: Yr,
  Calendar: ar,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    deselectAll: "Deselect all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand",
    collapse: "Collapse"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: Ce,
        method: Ce,
        array: Ce,
        object: Ce,
        number: Ce,
        date: Ce,
        boolean: Ce,
        integer: Ce,
        float: Ce,
        regexp: Ce,
        email: Ce,
        url: Ce,
        hex: Ce
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
}, Xn = $a;
Object.assign({}, Xn.Modal);
let Dn = [];
const sr = () => Dn.reduce((e, n) => Object.assign(Object.assign({}, e), n), Xn.Modal);
function Va(e) {
  if (e) {
    const n = Object.assign({}, e);
    return Dn.push(n), sr(), () => {
      Dn = Dn.filter((t) => t !== n), sr();
    };
  }
  Object.assign({}, Xn.Modal);
}
const Ua = /* @__PURE__ */ _t(void 0), qr = Ua, Qr = "internalMark", Zr = (e) => {
  const {
    locale: n = {},
    children: t,
    _ANT_MARK__: r
  } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = Tn("LocaleProvider");
    process.env.NODE_ENV !== "production" && i(r === Qr, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale");
  }
  S.useEffect(() => Va(n && n.Modal), [n]);
  const o = S.useMemo(() => Object.assign(Object.assign({}, n), {
    exist: !0
  }), [n]);
  return /* @__PURE__ */ S.createElement(qr.Provider, {
    value: o
  }, t);
};
process.env.NODE_ENV !== "production" && (Zr.displayName = "LocaleProvider");
const Wa = Zr, Jr = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
}, za = Object.assign(Object.assign({}, Jr), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: !1,
  // Motion
  motion: !0
}), Sn = za;
function Ba(e, n) {
  let {
    generateColorPalettes: t,
    generateNeutralColorPalettes: r
  } = n;
  const {
    colorSuccess: o,
    colorWarning: i,
    colorError: a,
    colorInfo: d,
    colorPrimary: h,
    colorBgBase: c,
    colorTextBase: p
  } = e, y = t(h), s = t(o), u = t(i), l = t(a), g = t(d), b = r(c, p), _ = e.colorLink || e.colorInfo, m = t(_);
  return Object.assign(Object.assign({}, b), {
    colorPrimaryBg: y[1],
    colorPrimaryBgHover: y[2],
    colorPrimaryBorder: y[3],
    colorPrimaryBorderHover: y[4],
    colorPrimaryHover: y[5],
    colorPrimary: y[6],
    colorPrimaryActive: y[7],
    colorPrimaryTextHover: y[8],
    colorPrimaryText: y[9],
    colorPrimaryTextActive: y[10],
    colorSuccessBg: s[1],
    colorSuccessBgHover: s[2],
    colorSuccessBorder: s[3],
    colorSuccessBorderHover: s[4],
    colorSuccessHover: s[4],
    colorSuccess: s[6],
    colorSuccessActive: s[7],
    colorSuccessTextHover: s[8],
    colorSuccessText: s[9],
    colorSuccessTextActive: s[10],
    colorErrorBg: l[1],
    colorErrorBgHover: l[2],
    colorErrorBgActive: l[3],
    colorErrorBorder: l[3],
    colorErrorBorderHover: l[4],
    colorErrorHover: l[5],
    colorError: l[6],
    colorErrorActive: l[7],
    colorErrorTextHover: l[8],
    colorErrorText: l[9],
    colorErrorTextActive: l[10],
    colorWarningBg: u[1],
    colorWarningBgHover: u[2],
    colorWarningBorder: u[3],
    colorWarningBorderHover: u[4],
    colorWarningHover: u[4],
    colorWarning: u[6],
    colorWarningActive: u[7],
    colorWarningTextHover: u[8],
    colorWarningText: u[9],
    colorWarningTextActive: u[10],
    colorInfoBg: g[1],
    colorInfoBgHover: g[2],
    colorInfoBorder: g[3],
    colorInfoBorderHover: g[4],
    colorInfoHover: g[4],
    colorInfo: g[6],
    colorInfoActive: g[7],
    colorInfoTextHover: g[8],
    colorInfoText: g[9],
    colorInfoTextActive: g[10],
    colorLinkHover: m[4],
    colorLink: m[6],
    colorLinkActive: m[7],
    colorBgMask: new xe("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}
const Ha = (e) => {
  let n = e, t = e, r = e, o = e;
  return e < 6 && e >= 5 ? n = e + 1 : e < 16 && e >= 6 ? n = e + 2 : e >= 16 && (n = 16), e < 7 && e >= 5 ? t = 4 : e < 8 && e >= 7 ? t = 5 : e < 14 && e >= 8 ? t = 6 : e < 16 && e >= 14 ? t = 7 : e >= 16 && (t = 8), e < 6 && e >= 2 ? r = 1 : e >= 6 && (r = 2), e > 4 && e < 8 ? o = 4 : e >= 8 && (o = 6), {
    borderRadius: e,
    borderRadiusXS: r,
    borderRadiusSM: t,
    borderRadiusLG: n,
    borderRadiusOuter: o
  };
}, Ka = Ha;
function Ga(e) {
  const {
    motionUnit: n,
    motionBase: t,
    borderRadius: r,
    lineWidth: o
  } = e;
  return Object.assign({
    // motion
    motionDurationFast: `${(t + n).toFixed(1)}s`,
    motionDurationMid: `${(t + n * 2).toFixed(1)}s`,
    motionDurationSlow: `${(t + n * 3).toFixed(1)}s`,
    // line
    lineWidthBold: o + 1
  }, Ka(r));
}
const Xa = (e) => {
  const {
    controlHeight: n
  } = e;
  return {
    controlHeightSM: n * 0.75,
    controlHeightXS: n * 0.5,
    controlHeightLG: n * 1.25
  };
}, Ya = Xa;
function qa(e) {
  return (e + 8) / e;
}
function Qa(e) {
  const n = new Array(10).fill(null).map((t, r) => {
    const o = r - 1, i = e * Math.pow(2.71828, o / 5), a = r > 1 ? Math.floor(i) : Math.ceil(i);
    return Math.floor(a / 2) * 2;
  });
  return n[1] = e, n.map((t) => ({
    size: t,
    lineHeight: qa(t)
  }));
}
const Za = (e) => {
  const n = Qa(e), t = n.map((p) => p.size), r = n.map((p) => p.lineHeight), o = t[1], i = t[0], a = t[2], d = r[1], h = r[0], c = r[2];
  return {
    fontSizeSM: i,
    fontSize: o,
    fontSizeLG: a,
    fontSizeXL: t[3],
    fontSizeHeading1: t[6],
    fontSizeHeading2: t[5],
    fontSizeHeading3: t[4],
    fontSizeHeading4: t[3],
    fontSizeHeading5: t[2],
    lineHeight: d,
    lineHeightLG: c,
    lineHeightSM: h,
    fontHeight: Math.round(d * o),
    fontHeightLG: Math.round(c * a),
    fontHeightSM: Math.round(h * i),
    lineHeightHeading1: r[6],
    lineHeightHeading2: r[5],
    lineHeightHeading3: r[4],
    lineHeightHeading4: r[3],
    lineHeightHeading5: r[2]
  };
}, Ja = Za;
function es(e) {
  const {
    sizeUnit: n,
    sizeStep: t
  } = e;
  return {
    sizeXXL: n * (t + 8),
    // 48
    sizeXL: n * (t + 4),
    // 32
    sizeLG: n * (t + 2),
    // 24
    sizeMD: n * (t + 1),
    // 20
    sizeMS: n * t,
    // 16
    size: n * t,
    // 16
    sizeSM: n * (t - 1),
    // 12
    sizeXS: n * (t - 2),
    // 8
    sizeXXS: n * (t - 3)
    // 4
  };
}
const He = (e, n) => new xe(e).setAlpha(n).toRgbString(), pn = (e, n) => new xe(e).darken(n).toHexString(), ns = (e) => {
  const n = wn(e);
  return {
    1: n[0],
    2: n[1],
    3: n[2],
    4: n[3],
    5: n[4],
    6: n[5],
    7: n[6],
    8: n[4],
    9: n[5],
    10: n[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
}, ts = (e, n) => {
  const t = e || "#fff", r = n || "#000";
  return {
    colorBgBase: t,
    colorTextBase: r,
    colorText: He(r, 0.88),
    colorTextSecondary: He(r, 0.65),
    colorTextTertiary: He(r, 0.45),
    colorTextQuaternary: He(r, 0.25),
    colorFill: He(r, 0.15),
    colorFillSecondary: He(r, 0.06),
    colorFillTertiary: He(r, 0.04),
    colorFillQuaternary: He(r, 0.02),
    colorBgLayout: pn(t, 4),
    colorBgContainer: pn(t, 0),
    colorBgElevated: pn(t, 0),
    colorBgSpotlight: He(r, 0.85),
    colorBgBlur: "transparent",
    colorBorder: pn(t, 15),
    colorBorderSecondary: pn(t, 6)
  };
};
function rs(e) {
  const n = Object.keys(Jr).map((t) => {
    const r = wn(e[t]);
    return new Array(10).fill(1).reduce((o, i, a) => (o[`${t}-${a + 1}`] = r[a], o[`${t}${a + 1}`] = r[a], o), {});
  }).reduce((t, r) => (t = Object.assign(Object.assign({}, t), r), t), {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, e), n), Ba(e, {
    generateColorPalettes: ns,
    generateNeutralColorPalettes: ts
  })), Ja(e.fontSize)), es(e)), Ya(e)), Ga(e));
}
const eo = ct(rs), mt = {
  token: Sn,
  override: {
    override: Sn
  },
  hashed: !0
}, no = /* @__PURE__ */ ne.createContext(mt), Rt = "anticon", os = (e, n) => n || (e ? `ant-${e}` : "ant"), tn = /* @__PURE__ */ S.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: os,
  iconPrefixCls: Rt
});
function is(e, n) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(n);
  for (var t = n; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var cr = "data-rc-order", lr = "data-rc-priority", as = "rc-util-key", gt = /* @__PURE__ */ new Map();
function to() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.mark;
  return n ? n.startsWith("data-") ? n : "data-".concat(n) : as;
}
function jt(e) {
  if (e.attachTo)
    return e.attachTo;
  var n = document.querySelector("head");
  return n || document.body;
}
function ss(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Dt(e) {
  return Array.from((gt.get(e) || e).children).filter(function(n) {
    return n.tagName === "STYLE";
  });
}
function ro(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!$r())
    return null;
  var t = n.csp, r = n.prepend, o = n.priority, i = o === void 0 ? 0 : o, a = ss(r), d = a === "prependQueue", h = document.createElement("style");
  h.setAttribute(cr, a), d && i && h.setAttribute(lr, "".concat(i)), t != null && t.nonce && (h.nonce = t == null ? void 0 : t.nonce), h.innerHTML = e;
  var c = jt(n), p = c.firstChild;
  if (r) {
    if (d) {
      var y = (n.styles || Dt(c)).filter(function(s) {
        if (!["prepend", "prependQueue"].includes(s.getAttribute(cr)))
          return !1;
        var u = Number(s.getAttribute(lr) || 0);
        return i >= u;
      });
      if (y.length)
        return c.insertBefore(h, y[y.length - 1].nextSibling), h;
    }
    c.insertBefore(h, p);
  } else
    c.appendChild(h);
  return h;
}
function cs(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = jt(n);
  return (n.styles || Dt(t)).find(function(r) {
    return r.getAttribute(to(n)) === e;
  });
}
function ls(e, n) {
  var t = gt.get(e);
  if (!t || !is(document, t)) {
    var r = ro("", n), o = r.parentNode;
    gt.set(e, o), e.removeChild(r);
  }
}
function us(e, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = jt(t), o = Dt(r), i = z(z({}, t), {}, {
    styles: o
  });
  ls(r, i);
  var a = cs(n, i);
  if (a) {
    var d, h;
    if ((d = i.csp) !== null && d !== void 0 && d.nonce && a.nonce !== ((h = i.csp) === null || h === void 0 ? void 0 : h.nonce)) {
      var c;
      a.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var p = ro(e, i);
  return p.setAttribute(to(i), n), p;
}
const ds = `-ant-${Date.now()}-${Math.random()}`;
function fs(e, n) {
  const t = {}, r = (a, d) => {
    let h = a.clone();
    return h = (d == null ? void 0 : d(h)) || h, h.toRgbString();
  }, o = (a, d) => {
    const h = new xe(a), c = wn(h.toRgbString());
    t[`${d}-color`] = r(h), t[`${d}-color-disabled`] = c[1], t[`${d}-color-hover`] = c[4], t[`${d}-color-active`] = c[6], t[`${d}-color-outline`] = h.clone().setAlpha(0.2).toRgbString(), t[`${d}-color-deprecated-bg`] = c[0], t[`${d}-color-deprecated-border`] = c[2];
  };
  if (n.primaryColor) {
    o(n.primaryColor, "primary");
    const a = new xe(n.primaryColor), d = wn(a.toRgbString());
    d.forEach((c, p) => {
      t[`primary-${p + 1}`] = c;
    }), t["primary-color-deprecated-l-35"] = r(a, (c) => c.lighten(35)), t["primary-color-deprecated-l-20"] = r(a, (c) => c.lighten(20)), t["primary-color-deprecated-t-20"] = r(a, (c) => c.tint(20)), t["primary-color-deprecated-t-50"] = r(a, (c) => c.tint(50)), t["primary-color-deprecated-f-12"] = r(a, (c) => c.setAlpha(c.getAlpha() * 0.12));
    const h = new xe(d[0]);
    t["primary-color-active-deprecated-f-30"] = r(h, (c) => c.setAlpha(c.getAlpha() * 0.3)), t["primary-color-active-deprecated-d-02"] = r(h, (c) => c.darken(2));
  }
  return n.successColor && o(n.successColor, "success"), n.warningColor && o(n.warningColor, "warning"), n.errorColor && o(n.errorColor, "error"), n.infoColor && o(n.infoColor, "info"), `
  :root {
    ${Object.keys(t).map((a) => `--${e}-${a}: ${t[a]};`).join(`
`)}
  }
  `.trim();
}
function ms(e, n) {
  const t = fs(e, n);
  $r() ? us(t, `${ds}-dynamic-theme`) : process.env.NODE_ENV !== "production" && Gn(!1, "ConfigProvider", "SSR do not support dynamic theme with css variables.");
}
const vt = /* @__PURE__ */ S.createContext(!1), gs = (e) => {
  let {
    children: n,
    disabled: t
  } = e;
  const r = S.useContext(vt);
  return /* @__PURE__ */ S.createElement(vt.Provider, {
    value: t ?? r
  }, n);
}, vs = vt, pt = /* @__PURE__ */ S.createContext(void 0), ps = (e) => {
  let {
    children: n,
    size: t
  } = e;
  const r = S.useContext(pt);
  return /* @__PURE__ */ S.createElement(pt.Provider, {
    value: t || r
  }, n);
}, $t = pt;
function hs() {
  const e = en(vs), n = en($t);
  return {
    componentDisabled: e,
    componentSize: n
  };
}
function bs(e, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, r = /* @__PURE__ */ new Set();
  function o(i, a) {
    var d = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, h = r.has(i);
    if (kt(!h, "Warning: There may be circular references"), h)
      return !1;
    if (i === a)
      return !0;
    if (t && d > 1)
      return !1;
    r.add(i);
    var c = d + 1;
    if (Array.isArray(i)) {
      if (!Array.isArray(a) || i.length !== a.length)
        return !1;
      for (var p = 0; p < i.length; p++)
        if (!o(i[p], a[p], c))
          return !1;
      return !0;
    }
    if (i && a && Oe(i) === "object" && Oe(a) === "object") {
      var y = Object.keys(i);
      return y.length !== Object.keys(a).length ? !1 : y.every(function(s) {
        return o(i[s], a[s], c);
      });
    }
    return !1;
  }
  return o(e, n);
}
const ys = "5.18.3";
function at(e) {
  return e >= 0 && e <= 255;
}
function _n(e, n) {
  const {
    r: t,
    g: r,
    b: o,
    a: i
  } = new xe(e).toRgb();
  if (i < 1)
    return e;
  const {
    r: a,
    g: d,
    b: h
  } = new xe(n).toRgb();
  for (let c = 0.01; c <= 1; c += 0.01) {
    const p = Math.round((t - a * (1 - c)) / c), y = Math.round((r - d * (1 - c)) / c), s = Math.round((o - h * (1 - c)) / c);
    if (at(p) && at(y) && at(s))
      return new xe({
        r: p,
        g: y,
        b: s,
        a: Math.round(c * 100) / 100
      }).toRgbString();
  }
  return new xe({
    r: t,
    g: r,
    b: o,
    a: 1
  }).toRgbString();
}
var ws = globalThis && globalThis.__rest || function(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
};
function oo(e) {
  const {
    override: n
  } = e, t = ws(e, ["override"]), r = Object.assign({}, n);
  Object.keys(Sn).forEach((s) => {
    delete r[s];
  });
  const o = Object.assign(Object.assign({}, t), r), i = 480, a = 576, d = 768, h = 992, c = 1200, p = 1600;
  if (o.motion === !1) {
    const s = "0s";
    o.motionDurationFast = s, o.motionDurationMid = s, o.motionDurationSlow = s;
  }
  return Object.assign(Object.assign(Object.assign({}, o), {
    // ============== Background ============== //
    colorFillContent: o.colorFillSecondary,
    colorFillContentHover: o.colorFill,
    colorFillAlter: o.colorFillQuaternary,
    colorBgContainerDisabled: o.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: o.colorBgContainer,
    colorSplit: _n(o.colorBorderSecondary, o.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: o.colorTextQuaternary,
    colorTextDisabled: o.colorTextQuaternary,
    colorTextHeading: o.colorText,
    colorTextLabel: o.colorTextSecondary,
    colorTextDescription: o.colorTextTertiary,
    colorTextLightSolid: o.colorWhite,
    colorHighlight: o.colorError,
    colorBgTextHover: o.colorFillSecondary,
    colorBgTextActive: o.colorFill,
    colorIcon: o.colorTextTertiary,
    colorIconHover: o.colorText,
    colorErrorOutline: _n(o.colorErrorBg, o.colorBgContainer),
    colorWarningOutline: _n(o.colorWarningBg, o.colorBgContainer),
    // Font
    fontSizeIcon: o.fontSizeSM,
    // Line
    lineWidthFocus: o.lineWidth * 4,
    // Control
    lineWidth: o.lineWidth,
    controlOutlineWidth: o.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: o.controlHeight / 2,
    controlItemBgHover: o.colorFillTertiary,
    controlItemBgActive: o.colorPrimaryBg,
    controlItemBgActiveHover: o.colorPrimaryBgHover,
    controlItemBgActiveDisabled: o.colorFill,
    controlTmpOutline: o.colorFillQuaternary,
    controlOutline: _n(o.colorPrimaryBg, o.colorBgContainer),
    lineType: o.lineType,
    borderRadius: o.borderRadius,
    borderRadiusXS: o.borderRadiusXS,
    borderRadiusSM: o.borderRadiusSM,
    borderRadiusLG: o.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: o.sizeXXS,
    paddingXS: o.sizeXS,
    paddingSM: o.sizeSM,
    padding: o.size,
    paddingMD: o.sizeMD,
    paddingLG: o.sizeLG,
    paddingXL: o.sizeXL,
    paddingContentHorizontalLG: o.sizeLG,
    paddingContentVerticalLG: o.sizeMS,
    paddingContentHorizontal: o.sizeMS,
    paddingContentVertical: o.sizeSM,
    paddingContentHorizontalSM: o.size,
    paddingContentVerticalSM: o.sizeXS,
    marginXXS: o.sizeXXS,
    marginXS: o.sizeXS,
    marginSM: o.sizeSM,
    margin: o.size,
    marginMD: o.sizeMD,
    marginLG: o.sizeLG,
    marginXL: o.sizeXL,
    marginXXL: o.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS: i,
    screenXSMin: i,
    screenXSMax: a - 1,
    screenSM: a,
    screenSMMin: a,
    screenSMMax: d - 1,
    screenMD: d,
    screenMDMin: d,
    screenMDMax: h - 1,
    screenLG: h,
    screenLGMin: h,
    screenLGMax: c - 1,
    screenXL: c,
    screenXLMin: c,
    screenXLMax: p - 1,
    screenXXL: p,
    screenXXLMin: p,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new xe("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new xe("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new xe("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), r);
}
var ur = globalThis && globalThis.__rest || function(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
};
const io = {
  lineHeight: !0,
  lineHeightSM: !0,
  lineHeightLG: !0,
  lineHeightHeading1: !0,
  lineHeightHeading2: !0,
  lineHeightHeading3: !0,
  lineHeightHeading4: !0,
  lineHeightHeading5: !0,
  opacityLoading: !0,
  fontWeightStrong: !0,
  zIndexPopupBase: !0,
  zIndexBase: !0
}, ao = {
  size: !0,
  sizeSM: !0,
  sizeLG: !0,
  sizeMD: !0,
  sizeXS: !0,
  sizeXXS: !0,
  sizeMS: !0,
  sizeXL: !0,
  sizeXXL: !0,
  sizeUnit: !0,
  sizeStep: !0,
  motionBase: !0,
  motionUnit: !0
}, Ss = {
  screenXS: !0,
  screenXSMin: !0,
  screenXSMax: !0,
  screenSM: !0,
  screenSMMin: !0,
  screenSMMax: !0,
  screenMD: !0,
  screenMDMin: !0,
  screenMDMax: !0,
  screenLG: !0,
  screenLGMin: !0,
  screenLGMax: !0,
  screenXL: !0,
  screenXLMin: !0,
  screenXLMax: !0,
  screenXXL: !0,
  screenXXLMin: !0
}, so = (e, n, t) => {
  const r = t.getDerivativeToken(e), {
    override: o
  } = n, i = ur(n, ["override"]);
  let a = Object.assign(Object.assign({}, r), {
    override: o
  });
  return a = oo(a), i && Object.entries(i).forEach((d) => {
    let [h, c] = d;
    const {
      theme: p
    } = c, y = ur(c, ["theme"]);
    let s = y;
    p && (s = so(Object.assign(Object.assign({}, a), y), {
      override: y
    }, p)), a[h] = s;
  }), a;
};
function nn() {
  const {
    token: e,
    hashed: n,
    theme: t,
    override: r,
    cssVar: o
  } = ne.useContext(no), i = `${ys}-${n || ""}`, a = t || eo, [d, h, c] = ua(a, [Sn, e], {
    salt: i,
    override: r,
    getComputedToken: so,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken: oo,
    cssVar: o && {
      prefix: o.prefix,
      key: o.key,
      unitless: io,
      ignore: ao,
      preserve: Ss
    }
  });
  return [a, c, n ? h : "", d, o];
}
function Es(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function En(e) {
  "@babel/helpers - typeof";
  return En = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, En(e);
}
function Cs(e, n) {
  if (En(e) != "object" || !e)
    return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, n || "default");
    if (En(r) != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (n === "string" ? String : Number)(e);
}
function xs(e) {
  var n = Cs(e, "string");
  return En(n) == "symbol" ? n : n + "";
}
function dr(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, xs(r.key), r);
  }
}
function Os(e, n, t) {
  return n && dr(e.prototype, n), t && dr(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
const Ts = 1e3 * 60 * 10;
let Ps = /* @__PURE__ */ function() {
  function e() {
    Es(this, e), this.map = /* @__PURE__ */ new Map(), this.objectIDMap = /* @__PURE__ */ new WeakMap(), this.nextID = 0, this.lastAccessBeat = /* @__PURE__ */ new Map(), this.accessBeat = 0;
  }
  return Os(e, [{
    key: "set",
    value: function(t, r) {
      this.clear();
      const o = this.getCompositeKey(t);
      this.map.set(o, r), this.lastAccessBeat.set(o, Date.now());
    }
  }, {
    key: "get",
    value: function(t) {
      const r = this.getCompositeKey(t), o = this.map.get(r);
      return this.lastAccessBeat.set(r, Date.now()), this.accessBeat += 1, o;
    }
  }, {
    key: "getCompositeKey",
    value: function(t) {
      return t.map((o) => o && typeof o == "object" ? `obj_${this.getObjectID(o)}` : `${typeof o}_${o}`).join("|");
    }
  }, {
    key: "getObjectID",
    value: function(t) {
      if (this.objectIDMap.has(t))
        return this.objectIDMap.get(t);
      const r = this.nextID;
      return this.objectIDMap.set(t, r), this.nextID += 1, r;
    }
  }, {
    key: "clear",
    value: function() {
      if (this.accessBeat > 1e4) {
        const t = Date.now();
        this.lastAccessBeat.forEach((r, o) => {
          t - r > Ts && (this.map.delete(o), this.lastAccessBeat.delete(o));
        }), this.accessBeat = 0;
      }
    }
  }]);
}();
const fr = new Ps();
function Ns(e, n) {
  return ne.useMemo(() => {
    const t = fr.get(n);
    if (t)
      return t;
    const r = e();
    return fr.set(n, r), r;
  }, n);
}
const Rd = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
}, Ms = function(e) {
  let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: e.colorText,
    fontSize: e.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: e.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: n ? "inherit" : e.fontFamily
  };
}, As = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
}), jd = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
}), Is = (e) => ({
  a: {
    color: e.colorLink,
    textDecoration: e.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${e.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: e.colorLinkHover
    },
    "&:active": {
      color: e.colorLinkActive
    },
    "&:active,\n  &:hover": {
      textDecoration: e.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: e.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: e.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
}), ks = (e, n, t, r) => {
  const o = `[class^="${n}"], [class*=" ${n}"]`, i = t ? `.${t}` : o, a = {
    boxSizing: "border-box",
    "&::before, &::after": {
      boxSizing: "border-box"
    }
  };
  let d = {};
  return r !== !1 && (d = {
    fontFamily: e.fontFamily,
    fontSize: e.fontSize
  }), {
    [i]: Object.assign(Object.assign(Object.assign({}, d), a), {
      [o]: a
    })
  };
}, _s = (e) => ({
  outline: `${lt(e.lineWidthFocus)} solid ${e.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
}), Dd = (e) => ({
  "&:focus-visible": Object.assign({}, _s(e))
});
function Ls(e) {
  return e === "js" ? {
    max: Math.max,
    min: Math.min
  } : {
    max: function() {
      for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
        t[r] = arguments[r];
      return `max(${t.map((o) => lt(o)).join(",")})`;
    },
    min: function() {
      for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
        t[r] = arguments[r];
      return `min(${t.map((o) => lt(o)).join(",")})`;
    }
  };
}
const co = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC < "u";
let ht = !0;
function Vt() {
  for (var e = arguments.length, n = new Array(e), t = 0; t < e; t++)
    n[t] = arguments[t];
  if (!co)
    return Object.assign.apply(Object, [{}].concat(n));
  ht = !1;
  const r = {};
  return n.forEach((o) => {
    Object.keys(o).forEach((a) => {
      Object.defineProperty(r, a, {
        configurable: !0,
        enumerable: !0,
        get: () => o[a]
      });
    });
  }), ht = !0, r;
}
const mr = {};
function Fs() {
}
const Rs = (e) => {
  let n, t = e, r = Fs;
  return co && typeof Proxy < "u" && (n = /* @__PURE__ */ new Set(), t = new Proxy(e, {
    get(o, i) {
      return ht && n.add(i), o[i];
    }
  }), r = (o, i) => {
    var a;
    mr[o] = {
      global: Array.from(n),
      component: Object.assign(Object.assign({}, (a = mr[o]) === null || a === void 0 ? void 0 : a.component), i)
    };
  }), {
    token: t,
    keys: n,
    flush: r
  };
}, js = (e, n) => {
  const [t, r] = nn();
  return ut({
    theme: t,
    token: r,
    hashId: "",
    path: ["ant-design-icons", e],
    nonce: () => n == null ? void 0 : n.nonce,
    layer: {
      name: "antd"
    }
  }, () => [{
    [`.${e}`]: Object.assign(Object.assign({}, As()), {
      [`.${e} .${e}-icon`]: {
        display: "block"
      }
    })
  }]);
}, lo = js, uo = (e, n, t) => {
  var r;
  return typeof t == "function" ? t(Vt(n, (r = n[e]) !== null && r !== void 0 ? r : {})) : t ?? {};
}, fo = (e, n, t, r) => {
  const o = Object.assign({}, n[e]);
  if (r != null && r.deprecatedTokens) {
    const {
      deprecatedTokens: a
    } = r;
    a.forEach((d) => {
      let [h, c] = d;
      var p;
      process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "production" && kt(!(o != null && o[h]), `Component Token \`${String(h)}\` of ${e} is deprecated. Please use \`${String(c)}\` instead.`), (o != null && o[h] || o != null && o[c]) && ((p = o[c]) !== null && p !== void 0 || (o[c] = o == null ? void 0 : o[h]));
    });
  }
  const i = Object.assign(Object.assign({}, t), o);
  return Object.keys(i).forEach((a) => {
    i[a] === n[a] && delete i[a];
  }), i;
}, gr = (e, n) => `${[n, e.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function mo(e, n, t) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const o = Array.isArray(e) ? e : [e, e], [i] = o, a = o.join("-");
  return function(d) {
    let h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : d;
    const [c, p, y, s, u] = nn(), {
      getPrefixCls: l,
      iconPrefixCls: g,
      csp: b
    } = en(tn), _ = l(), m = u ? "css" : "js", f = Ns(() => {
      const T = /* @__PURE__ */ new Set();
      return u && Object.keys(r.unitless || {}).forEach((N) => {
        T.add(ot(N, u.prefix)), T.add(ot(N, gr(i, u.prefix)));
      }), da(m, T);
    }, [m, i, u && u.prefix]), {
      max: v,
      min: w
    } = Ls(m), E = {
      theme: c,
      token: s,
      hashId: y,
      nonce: () => b == null ? void 0 : b.nonce,
      clientOnly: r.clientOnly,
      layer: {
        name: "antd"
      },
      // antd is always at top of styles
      order: r.order || -999
    };
    return ut(Object.assign(Object.assign({}, E), {
      clientOnly: !1,
      path: ["Shared", _]
    }), () => [{
      // Link
      "&": Is(s)
    }]), lo(g, b), [ut(Object.assign(Object.assign({}, E), {
      path: [a, d, g]
    }), () => {
      if (r.injectStyle === !1)
        return [];
      const {
        token: T,
        flush: N
      } = Rs(s), L = uo(i, p, t), R = `.${d}`, Z = fo(i, p, L, {
        deprecatedTokens: r.deprecatedTokens
      });
      u && Object.keys(L).forEach((G) => {
        L[G] = `var(${ot(G, gr(i, u.prefix))})`;
      });
      const W = Vt(T, {
        componentCls: R,
        prefixCls: d,
        iconCls: `.${g}`,
        antCls: `.${_}`,
        calc: f,
        // @ts-ignore
        max: v,
        // @ts-ignore
        min: w
      }, u ? L : Z), K = n(W, {
        hashId: y,
        prefixCls: d,
        rootPrefixCls: _,
        iconPrefixCls: g
      });
      return N(i, Z), [r.resetStyle === !1 ? null : ks(W, d, h, r.resetFont), K];
    }), y];
  };
}
const $d = (e, n, t, r) => {
  const o = mo(e, n, t, Object.assign({
    resetStyle: !1,
    // Sub Style should default after root one
    order: -998
  }, r)), i = (a) => {
    let {
      prefixCls: d,
      rootCls: h = d
    } = a;
    return o(d, h), null;
  };
  return process.env.NODE_ENV !== "production" && (i.displayName = `SubStyle_${Array.isArray(e) ? e.join(".") : e}`), i;
}, Ds = (e, n, t) => {
  const {
    unitless: r,
    injectStyle: o = !0,
    prefixToken: i
  } = t, a = (h) => {
    let {
      rootCls: c,
      cssVar: p
    } = h;
    const [, y] = nn();
    return fa({
      path: [e],
      prefix: p.prefix,
      key: p == null ? void 0 : p.key,
      unitless: r,
      ignore: ao,
      token: y,
      scope: c
    }, () => {
      const s = uo(e, y, n), u = fo(e, y, s, {
        deprecatedTokens: t == null ? void 0 : t.deprecatedTokens
      });
      return Object.keys(s).forEach((l) => {
        u[i(l)] = u[l], delete u[l];
      }), u;
    }), null;
  };
  return (h) => {
    const [, , , , c] = nn();
    return [(p) => o && c ? /* @__PURE__ */ ne.createElement(ne.Fragment, null, /* @__PURE__ */ ne.createElement(a, {
      rootCls: h,
      cssVar: c,
      component: e
    }), p) : p, c == null ? void 0 : c.key];
  };
}, $s = (e, n, t, r) => {
  const o = Array.isArray(e) ? e[0] : e;
  function i(y) {
    return `${o}${y.slice(0, 1).toUpperCase()}${y.slice(1)}`;
  }
  const a = r && r.unitless || {}, d = Object.assign(Object.assign({}, io), {
    [i("zIndexPopup")]: !0
  });
  Object.keys(a).forEach((y) => {
    d[i(y)] = a[y];
  });
  const h = Object.assign(Object.assign({}, r), {
    unitless: d,
    prefixToken: i
  }), c = mo(e, n, t, h), p = Ds(o, t, h);
  return function(y) {
    let s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : y;
    const [, u] = c(y, s), [l, g] = p(s);
    return [l, u, g];
  };
}, Vs = Object.assign({}, S), {
  useId: vr
} = Vs, Us = () => "", Ws = typeof vr > "u" ? Us : vr, zs = Ws;
function Bs(e, n, t) {
  var r, o;
  const i = Tn("ConfigProvider"), a = e || {}, d = a.inherit === !1 || !n ? Object.assign(Object.assign({}, mt), {
    hashed: (r = n == null ? void 0 : n.hashed) !== null && r !== void 0 ? r : mt.hashed,
    cssVar: n == null ? void 0 : n.cssVar
  }) : n, h = zs();
  if (process.env.NODE_ENV !== "production") {
    const c = a.cssVar || d.cssVar, p = !!(typeof a.cssVar == "object" && (!((o = a.cssVar) === null || o === void 0) && o.key) || h);
    process.env.NODE_ENV !== "production" && i(!c || p, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.");
  }
  return Vr(() => {
    var c, p;
    if (!e)
      return n;
    const y = Object.assign({}, d.components);
    Object.keys(e.components || {}).forEach((l) => {
      y[l] = Object.assign(Object.assign({}, y[l]), e.components[l]);
    });
    const s = `css-var-${h.replace(/:/g, "")}`, u = ((c = a.cssVar) !== null && c !== void 0 ? c : d.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: t == null ? void 0 : t.prefixCls
    }, typeof d.cssVar == "object" ? d.cssVar : {}), typeof a.cssVar == "object" ? a.cssVar : {}), {
      key: typeof a.cssVar == "object" && ((p = a.cssVar) === null || p === void 0 ? void 0 : p.key) || s
    });
    return Object.assign(Object.assign(Object.assign({}, d), a), {
      token: Object.assign(Object.assign({}, d.token), a.token),
      components: y,
      cssVar: u
    });
  }, [a, d], (c, p) => c.some((y, s) => {
    const u = p[s];
    return !bs(y, u, !0);
  }));
}
function Hs(e) {
  const {
    children: n
  } = e, [, t] = nn(), {
    motion: r
  } = t, o = S.useRef(!1);
  return o.current = o.current || r === !1, o.current ? /* @__PURE__ */ S.createElement(ma, {
    motion: r
  }, n) : n;
}
const go = /* @__PURE__ */ S.memo((e) => {
  let {
    dropdownMatchSelectWidth: n
  } = e;
  return Tn("ConfigProvider").deprecated(n === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth"), null;
});
process.env.NODE_ENV !== "production" && (go.displayName = "PropWarning");
const Ks = process.env.NODE_ENV !== "production" ? go : () => null;
var Gs = globalThis && globalThis.__rest || function(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
};
let bt = !1;
const Xs = process.env.NODE_ENV !== "production" ? (e) => {
  process.env.NODE_ENV !== "production" && Gn(!bt, e, "Static function can not consume context like dynamic theme. Please use 'App' component instead.");
} : (
  /* istanbul ignore next */
  null
), Ys = ["getTargetContainer", "getPopupContainer", "renderEmpty", "input", "pagination", "form", "select", "button"], qs = "ant";
let Wn, vo, po, ho;
function $n() {
  return Wn || qs;
}
function Qs() {
  return vo || Rt;
}
function Zs(e) {
  return Object.keys(e).some((n) => n.endsWith("Color"));
}
const Js = (e) => {
  const {
    prefixCls: n,
    iconPrefixCls: t,
    theme: r,
    holderRender: o
  } = e;
  n !== void 0 && (Wn = n), t !== void 0 && (vo = t), "holderRender" in e && (ho = o), r && (Zs(r) ? (process.env.NODE_ENV !== "production" && Gn(!1, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead."), ms($n(), r)) : po = r);
}, bo = () => ({
  getPrefixCls: (e, n) => n || (e ? `${$n()}-${e}` : $n()),
  getIconPrefixCls: Qs,
  getRootPrefixCls: () => Wn || $n(),
  getTheme: () => po,
  holderRender: ho
}), ec = (e) => {
  const {
    children: n,
    csp: t,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    form: a,
    locale: d,
    componentSize: h,
    direction: c,
    space: p,
    virtual: y,
    dropdownMatchSelectWidth: s,
    popupMatchSelectWidth: u,
    popupOverflow: l,
    legacyLocale: g,
    parentContext: b,
    iconPrefixCls: _,
    theme: m,
    componentDisabled: f,
    segmented: v,
    statistic: w,
    spin: E,
    calendar: P,
    carousel: T,
    cascader: N,
    collapse: L,
    typography: R,
    checkbox: Z,
    descriptions: W,
    divider: K,
    drawer: G,
    skeleton: x,
    steps: C,
    image: O,
    layout: A,
    list: I,
    mentions: k,
    modal: B,
    progress: H,
    result: X,
    slider: V,
    breadcrumb: Y,
    menu: ce,
    pagination: $e,
    input: Se,
    textArea: pe,
    empty: Le,
    badge: Pe,
    radio: Ne,
    rate: he,
    switch: ye,
    transfer: Fe,
    avatar: be,
    message: Ee,
    tag: ie,
    table: re,
    card: oe,
    tabs: ee,
    timeline: fe,
    timePicker: Re,
    upload: $,
    notification: q,
    tree: U,
    colorPicker: J,
    datePicker: Ve,
    rangePicker: Me,
    flex: Q,
    wave: j,
    dropdown: Ae,
    warning: mn,
    tour: An,
    floatButtonGroup: na
  } = e, Qt = S.useCallback((se, de) => {
    const {
      prefixCls: Ue
    } = e;
    if (de)
      return de;
    const We = Ue || b.getPrefixCls("");
    return se ? `${We}-${se}` : We;
  }, [b.getPrefixCls, e.prefixCls]), gn = _ || b.iconPrefixCls || Rt, vn = t || b.csp;
  lo(gn, vn);
  const In = Bs(m, b.theme, {
    prefixCls: Qt("")
  });
  process.env.NODE_ENV !== "production" && (bt = bt || !!In);
  const tt = {
    csp: vn,
    autoInsertSpaceInButton: r,
    alert: o,
    anchor: i,
    locale: d || g,
    direction: c,
    space: p,
    virtual: y,
    popupMatchSelectWidth: u ?? s,
    popupOverflow: l,
    getPrefixCls: Qt,
    iconPrefixCls: gn,
    theme: In,
    segmented: v,
    statistic: w,
    spin: E,
    calendar: P,
    carousel: T,
    cascader: N,
    collapse: L,
    typography: R,
    checkbox: Z,
    descriptions: W,
    divider: K,
    drawer: G,
    skeleton: x,
    steps: C,
    image: O,
    input: Se,
    textArea: pe,
    layout: A,
    list: I,
    mentions: k,
    modal: B,
    progress: H,
    result: X,
    slider: V,
    breadcrumb: Y,
    menu: ce,
    pagination: $e,
    empty: Le,
    badge: Pe,
    radio: Ne,
    rate: he,
    switch: ye,
    transfer: Fe,
    avatar: be,
    message: Ee,
    tag: ie,
    table: re,
    card: oe,
    tabs: ee,
    timeline: fe,
    timePicker: Re,
    upload: $,
    notification: q,
    tree: U,
    colorPicker: J,
    datePicker: Ve,
    rangePicker: Me,
    flex: Q,
    wave: j,
    dropdown: Ae,
    warning: mn,
    tour: An,
    floatButtonGroup: na
  };
  process.env.NODE_ENV !== "production" && Tn("ConfigProvider")(!("autoInsertSpaceInButton" in e), "deprecated", "`autoInsertSpaceInButton` is deprecated. Please use `{ button: { autoInsertSpace: boolean }}` instead.");
  const on = Object.assign({}, b);
  Object.keys(tt).forEach((se) => {
    tt[se] !== void 0 && (on[se] = tt[se]);
  }), Ys.forEach((se) => {
    const de = e[se];
    de && (on[se] = de);
  }), typeof r < "u" && (on.button = Object.assign({
    autoInsertSpace: r
  }, on.button));
  const an = Vr(() => on, on, (se, de) => {
    const Ue = Object.keys(se), We = Object.keys(de);
    return Ue.length !== We.length || Ue.some((kn) => se[kn] !== de[kn]);
  }), ta = S.useMemo(() => ({
    prefixCls: gn,
    csp: vn
  }), [gn, vn]);
  let ue = /* @__PURE__ */ S.createElement(S.Fragment, null, /* @__PURE__ */ S.createElement(Ks, {
    dropdownMatchSelectWidth: s
  }), n);
  const Zt = S.useMemo(() => {
    var se, de, Ue, We;
    return ga(((se = Xn.Form) === null || se === void 0 ? void 0 : se.defaultValidateMessages) || {}, ((Ue = (de = an.locale) === null || de === void 0 ? void 0 : de.Form) === null || Ue === void 0 ? void 0 : Ue.defaultValidateMessages) || {}, ((We = an.form) === null || We === void 0 ? void 0 : We.validateMessages) || {}, (a == null ? void 0 : a.validateMessages) || {});
  }, [an, a == null ? void 0 : a.validateMessages]);
  Object.keys(Zt).length > 0 && (ue = /* @__PURE__ */ S.createElement(La.Provider, {
    value: Zt
  }, ue)), d && (ue = /* @__PURE__ */ S.createElement(Wa, {
    locale: d,
    _ANT_MARK__: Qr
  }, ue)), (gn || vn) && (ue = /* @__PURE__ */ S.createElement(Lt.Provider, {
    value: ta
  }, ue)), h && (ue = /* @__PURE__ */ S.createElement(ps, {
    size: h
  }, ue)), ue = /* @__PURE__ */ S.createElement(Hs, null, ue);
  const ra = S.useMemo(() => {
    const se = In || {}, {
      algorithm: de,
      token: Ue,
      components: We,
      cssVar: kn
    } = se, oa = Gs(se, ["algorithm", "token", "components", "cssVar"]), Jt = de && (!Array.isArray(de) || de.length > 0) ? ct(de) : eo, rt = {};
    Object.entries(We || {}).forEach((ia) => {
      let [aa, sa] = ia;
      const Be = Object.assign({}, sa);
      "algorithm" in Be && (Be.algorithm === !0 ? Be.theme = Jt : (Array.isArray(Be.algorithm) || typeof Be.algorithm == "function") && (Be.theme = ct(Be.algorithm)), delete Be.algorithm), rt[aa] = Be;
    });
    const er = Object.assign(Object.assign({}, Sn), Ue);
    return Object.assign(Object.assign({}, oa), {
      theme: Jt,
      token: er,
      components: rt,
      override: Object.assign({
        override: er
      }, rt),
      cssVar: kn
    });
  }, [In]);
  return m && (ue = /* @__PURE__ */ S.createElement(no.Provider, {
    value: ra
  }, ue)), an.warning && (ue = /* @__PURE__ */ S.createElement(Xr.Provider, {
    value: an.warning
  }, ue)), f !== void 0 && (ue = /* @__PURE__ */ S.createElement(gs, {
    disabled: f
  }, ue)), /* @__PURE__ */ S.createElement(tn.Provider, {
    value: an
  }, ue);
}, rn = (e) => {
  const n = S.useContext(tn), t = S.useContext(qr);
  return /* @__PURE__ */ S.createElement(ec, Object.assign({
    parentContext: n,
    legacyLocale: t
  }, e));
};
rn.ConfigContext = tn;
rn.SizeContext = $t;
rn.config = Js;
rn.useConfig = hs;
Object.defineProperty(rn, "SizeContext", {
  get: () => (process.env.NODE_ENV !== "production" && Gn(!1, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead."), $t)
});
process.env.NODE_ENV !== "production" && (rn.displayName = "ConfigProvider");
var nc = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, name: "check-circle", theme: "filled" };
const tc = nc;
function rc() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function oc(e, n) {
  if (!e)
    return !1;
  if (e.contains)
    return e.contains(n);
  for (var t = n; t; ) {
    if (t === e)
      return !0;
    t = t.parentNode;
  }
  return !1;
}
var pr = "data-rc-order", hr = "data-rc-priority", ic = "rc-util-key", yt = /* @__PURE__ */ new Map();
function yo() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.mark;
  return n ? n.startsWith("data-") ? n : "data-".concat(n) : ic;
}
function Ut(e) {
  if (e.attachTo)
    return e.attachTo;
  var n = document.querySelector("head");
  return n || document.body;
}
function ac(e) {
  return e === "queue" ? "prependQueue" : e ? "prepend" : "append";
}
function Wt(e) {
  return Array.from((yt.get(e) || e).children).filter(function(n) {
    return n.tagName === "STYLE";
  });
}
function wo(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!rc())
    return null;
  var t = n.csp, r = n.prepend, o = n.priority, i = o === void 0 ? 0 : o, a = ac(r), d = a === "prependQueue", h = document.createElement("style");
  h.setAttribute(pr, a), d && i && h.setAttribute(hr, "".concat(i)), t != null && t.nonce && (h.nonce = t == null ? void 0 : t.nonce), h.innerHTML = e;
  var c = Ut(n), p = c.firstChild;
  if (r) {
    if (d) {
      var y = (n.styles || Wt(c)).filter(function(s) {
        if (!["prepend", "prependQueue"].includes(s.getAttribute(pr)))
          return !1;
        var u = Number(s.getAttribute(hr) || 0);
        return i >= u;
      });
      if (y.length)
        return c.insertBefore(h, y[y.length - 1].nextSibling), h;
    }
    c.insertBefore(h, p);
  } else
    c.appendChild(h);
  return h;
}
function sc(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = Ut(n);
  return (n.styles || Wt(t)).find(function(r) {
    return r.getAttribute(yo(n)) === e;
  });
}
function cc(e, n) {
  var t = yt.get(e);
  if (!t || !oc(document, t)) {
    var r = wo("", n), o = r.parentNode;
    yt.set(e, o), e.removeChild(r);
  }
}
function lc(e, n) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Ut(t), o = Wt(r), i = z(z({}, t), {}, {
    styles: o
  });
  cc(r, i);
  var a = sc(n, i);
  if (a) {
    var d, h;
    if ((d = i.csp) !== null && d !== void 0 && d.nonce && a.nonce !== ((h = i.csp) === null || h === void 0 ? void 0 : h.nonce)) {
      var c;
      a.nonce = (c = i.csp) === null || c === void 0 ? void 0 : c.nonce;
    }
    return a.innerHTML !== e && (a.innerHTML = e), a;
  }
  var p = wo(e, i);
  return p.setAttribute(yo(i), n), p;
}
function So(e) {
  var n;
  return e == null || (n = e.getRootNode) === null || n === void 0 ? void 0 : n.call(e);
}
function uc(e) {
  return So(e) instanceof ShadowRoot;
}
function dc(e) {
  return uc(e) ? So(e) : null;
}
var wt = {}, zt = [], fc = function(n) {
  zt.push(n);
};
function mc(e, n) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0)
    var t = zt.reduce(function(r, o) {
      return o(r ?? "", "warning");
    }, n);
}
function gc(e, n) {
  if (process.env.NODE_ENV !== "production" && !e && console !== void 0)
    var t = zt.reduce(function(r, o) {
      return o(r ?? "", "note");
    }, n);
}
function vc() {
  wt = {};
}
function Eo(e, n, t) {
  !n && !wt[t] && (e(!1, t), wt[t] = !0);
}
function Yn(e, n) {
  Eo(mc, e, n);
}
function pc(e, n) {
  Eo(gc, e, n);
}
Yn.preMessage = fc;
Yn.resetWarned = vc;
Yn.noteOnce = pc;
function hc(e) {
  return e.replace(/-(.)/g, function(n, t) {
    return t.toUpperCase();
  });
}
function bc(e, n) {
  Yn(e, "[@ant-design/icons] ".concat(n));
}
function br(e) {
  return Oe(e) === "object" && typeof e.name == "string" && typeof e.theme == "string" && (Oe(e.icon) === "object" || typeof e.icon == "function");
}
function yr() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(e).reduce(function(n, t) {
    var r = e[t];
    switch (t) {
      case "class":
        n.className = r, delete n.class;
        break;
      default:
        delete n[t], n[hc(t)] = r;
    }
    return n;
  }, {});
}
function St(e, n, t) {
  return t ? /* @__PURE__ */ ne.createElement(e.tag, z(z({
    key: n
  }, yr(e.attrs)), t), (e.children || []).map(function(r, o) {
    return St(r, "".concat(n, "-").concat(e.tag, "-").concat(o));
  })) : /* @__PURE__ */ ne.createElement(e.tag, z({
    key: n
  }, yr(e.attrs)), (e.children || []).map(function(r, o) {
    return St(r, "".concat(n, "-").concat(e.tag, "-").concat(o));
  }));
}
function Co(e) {
  return wn(e)[0];
}
function xo(e) {
  return e ? Array.isArray(e) ? e : [e] : [];
}
var yc = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`, wc = function(n) {
  var t = en(Lt), r = t.csp, o = t.prefixCls, i = yc;
  o && (i = i.replace(/anticon/g, o)), Je(function() {
    var a = n.current, d = dc(a);
    lc(i, "@ant-design-icons", {
      prepend: !0,
      csp: r,
      attachTo: d
    });
  }, []);
}, Sc = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"], bn = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: !1
};
function Ec(e) {
  var n = e.primaryColor, t = e.secondaryColor;
  bn.primaryColor = n, bn.secondaryColor = t || Co(n), bn.calculated = !!t;
}
function Cc() {
  return z({}, bn);
}
var qn = function(n) {
  var t = n.icon, r = n.className, o = n.onClick, i = n.style, a = n.primaryColor, d = n.secondaryColor, h = un(n, Sc), c = S.useRef(), p = bn;
  if (a && (p = {
    primaryColor: a,
    secondaryColor: d || Co(a)
  }), wc(c), bc(br(t), "icon should be icon definiton, but got ".concat(t)), !br(t))
    return null;
  var y = t;
  return y && typeof y.icon == "function" && (y = z(z({}, y), {}, {
    icon: y.icon(p.primaryColor, p.secondaryColor)
  })), St(y.icon, "svg-".concat(y.name), z(z({
    className: r,
    onClick: o,
    style: i,
    "data-icon": y.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, h), {}, {
    ref: c
  }));
};
qn.displayName = "IconReact";
qn.getTwoToneColors = Cc;
qn.setTwoToneColors = Ec;
const Bt = qn;
function Oo(e) {
  var n = xo(e), t = ae(n, 2), r = t[0], o = t[1];
  return Bt.setTwoToneColors({
    primaryColor: r,
    secondaryColor: o
  });
}
function xc() {
  var e = Bt.getTwoToneColors();
  return e.calculated ? [e.primaryColor, e.secondaryColor] : e.primaryColor;
}
var Oc = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
Oo(va.primary);
var Qn = /* @__PURE__ */ S.forwardRef(function(e, n) {
  var t = e.className, r = e.icon, o = e.spin, i = e.rotate, a = e.tabIndex, d = e.onClick, h = e.twoToneColor, c = un(e, Oc), p = S.useContext(Lt), y = p.prefixCls, s = y === void 0 ? "anticon" : y, u = p.rootClassName, l = De(u, s, le(le({}, "".concat(s, "-").concat(r.name), !!r.name), "".concat(s, "-spin"), !!o || r.name === "loading"), t), g = a;
  g === void 0 && d && (g = -1);
  var b = i ? {
    msTransform: "rotate(".concat(i, "deg)"),
    transform: "rotate(".concat(i, "deg)")
  } : void 0, _ = xo(h), m = ae(_, 2), f = m[0], v = m[1];
  return /* @__PURE__ */ S.createElement("span", ke({
    role: "img",
    "aria-label": r.name
  }, c, {
    ref: n,
    tabIndex: g,
    onClick: d,
    className: l
  }), /* @__PURE__ */ S.createElement(Bt, {
    icon: r,
    primaryColor: f,
    secondaryColor: v,
    style: b
  }));
});
Qn.displayName = "AntdIcon";
Qn.getTwoToneColor = xc;
Qn.setTwoToneColor = Oo;
const dn = Qn;
var Tc = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: tc
  }));
}, To = /* @__PURE__ */ S.forwardRef(Tc);
process.env.NODE_ENV !== "production" && (To.displayName = "CheckCircleFilled");
const Pc = To;
var Nc = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, name: "close-circle", theme: "filled" };
const Mc = Nc;
var Ac = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: Mc
  }));
}, Po = /* @__PURE__ */ S.forwardRef(Ac);
process.env.NODE_ENV !== "production" && (Po.displayName = "CloseCircleFilled");
const Ic = Po;
var kc = { icon: { tag: "svg", attrs: { "fill-rule": "evenodd", viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, name: "close", theme: "outlined" };
const _c = kc;
var Lc = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: _c
  }));
}, No = /* @__PURE__ */ S.forwardRef(Lc);
process.env.NODE_ENV !== "production" && (No.displayName = "CloseOutlined");
const Fc = No;
var Rc = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "exclamation-circle", theme: "filled" };
const jc = Rc;
var Dc = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: jc
  }));
}, Mo = /* @__PURE__ */ S.forwardRef(Dc);
process.env.NODE_ENV !== "production" && (Mo.displayName = "ExclamationCircleFilled");
const $c = Mo;
var Vc = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, name: "info-circle", theme: "filled" };
const Uc = Vc;
var Wc = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: Uc
  }));
}, Ao = /* @__PURE__ */ S.forwardRef(Wc);
process.env.NODE_ENV !== "production" && (Ao.displayName = "InfoCircleFilled");
const zc = Ao, Bc = (e) => {
  const [, , , , n] = nn();
  return n ? `${e}-css-var` : "";
}, Io = Bc;
function Hc(e) {
  return e instanceof HTMLElement || e instanceof SVGElement;
}
function Kc(e) {
  return Hc(e) ? e : e instanceof ne.Component ? pa.findDOMNode(e) : null;
}
function Gc(e, n) {
  typeof e == "function" ? e(n) : Oe(e) === "object" && e && "current" in e && (e.current = n);
}
function Xc(e) {
  var n, t, r = it.isMemo(e) ? e.type.type : e.type;
  return !(typeof r == "function" && !((n = r.prototype) !== null && n !== void 0 && n.render) && r.$$typeof !== it.ForwardRef || typeof e == "function" && !((t = e.prototype) !== null && t !== void 0 && t.render) && e.$$typeof !== it.ForwardRef);
}
var Yc = /* @__PURE__ */ S.createContext({}), qc = /* @__PURE__ */ function(e) {
  Ur(t, e);
  var n = Wr(t);
  function t() {
    return zr(this, t), n.apply(this, arguments);
  }
  return Br(t, [{
    key: "render",
    value: function() {
      return this.props.children;
    }
  }]), t;
}(S.Component);
function Vn(e) {
  var n = S.useRef(!1), t = S.useState(e), r = ae(t, 2), o = r[0], i = r[1];
  S.useEffect(function() {
    return n.current = !1, function() {
      n.current = !0;
    };
  }, []);
  function a(d, h) {
    h && n.current || i(d);
  }
  return [o, a];
}
var qe = "none", Ln = "appear", Fn = "enter", Rn = "leave", wr = "none", je = "prepare", sn = "start", cn = "active", Ht = "end", ko = "prepared";
function Kt() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Sr(e, n) {
  var t = {};
  return t[e.toLowerCase()] = n.toLowerCase(), t["Webkit".concat(e)] = "webkit".concat(n), t["Moz".concat(e)] = "moz".concat(n), t["ms".concat(e)] = "MS".concat(n), t["O".concat(e)] = "o".concat(n.toLowerCase()), t;
}
function Qc(e, n) {
  var t = {
    animationend: Sr("Animation", "AnimationEnd"),
    transitionend: Sr("Transition", "TransitionEnd")
  };
  return e && ("AnimationEvent" in n || delete t.animationend.animation, "TransitionEvent" in n || delete t.transitionend.transition), t;
}
var Zc = Qc(Kt(), typeof window < "u" ? window : {}), _o = {};
if (Kt()) {
  var Jc = document.createElement("div");
  _o = Jc.style;
}
var jn = {};
function Lo(e) {
  if (jn[e])
    return jn[e];
  var n = Zc[e];
  if (n)
    for (var t = Object.keys(n), r = t.length, o = 0; o < r; o += 1) {
      var i = t[o];
      if (Object.prototype.hasOwnProperty.call(n, i) && i in _o)
        return jn[e] = n[i], jn[e];
    }
  return "";
}
var Fo = Lo("animationend"), Ro = Lo("transitionend"), jo = !!(Fo && Ro), Er = Fo || "animationend", Cr = Ro || "transitionend";
function xr(e, n) {
  if (!e)
    return null;
  if (Oe(e) === "object") {
    var t = n.replace(/-\w/g, function(r) {
      return r[1].toUpperCase();
    });
    return e[t];
  }
  return "".concat(e, "-").concat(n);
}
const el = function(e) {
  var n = Ge(), t = Ge(e);
  t.current = e;
  var r = S.useCallback(function(a) {
    t.current(a);
  }, []);
  function o(a) {
    a && (a.removeEventListener(Cr, r), a.removeEventListener(Er, r));
  }
  function i(a) {
    n.current && n.current !== a && o(n.current), a && a !== n.current && (a.addEventListener(Cr, r), a.addEventListener(Er, r), n.current = a);
  }
  return S.useEffect(function() {
    return function() {
      o(n.current);
    };
  }, []), [i, o];
};
var Do = Kt() ? wa : Je, $o = function(n) {
  return +setTimeout(n, 16);
}, Vo = function(n) {
  return clearTimeout(n);
};
typeof window < "u" && "requestAnimationFrame" in window && ($o = function(n) {
  return window.requestAnimationFrame(n);
}, Vo = function(n) {
  return window.cancelAnimationFrame(n);
});
var Or = 0, Zn = /* @__PURE__ */ new Map();
function Uo(e) {
  Zn.delete(e);
}
var zn = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  Or += 1;
  var r = Or;
  function o(i) {
    if (i === 0)
      Uo(r), n();
    else {
      var a = $o(function() {
        o(i - 1);
      });
      Zn.set(r, a);
    }
  }
  return o(t), r;
};
zn.cancel = function(e) {
  var n = Zn.get(e);
  return Uo(e), Vo(n);
};
process.env.NODE_ENV !== "production" && (zn.ids = function() {
  return Zn;
});
const nl = function() {
  var e = S.useRef(null);
  function n() {
    zn.cancel(e.current);
  }
  function t(r) {
    var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    n();
    var i = zn(function() {
      o <= 1 ? r({
        isCanceled: function() {
          return i !== e.current;
        }
      }) : t(r, o - 1);
    });
    e.current = i;
  }
  return S.useEffect(function() {
    return function() {
      n();
    };
  }, []), [t, n];
};
var tl = [je, sn, cn, Ht], rl = [je, ko], Wo = !1, ol = !0;
function zo(e) {
  return e === cn || e === Ht;
}
const il = function(e, n, t) {
  var r = Vn(wr), o = ae(r, 2), i = o[0], a = o[1], d = nl(), h = ae(d, 2), c = h[0], p = h[1];
  function y() {
    a(je, !0);
  }
  var s = n ? rl : tl;
  return Do(function() {
    if (i !== wr && i !== Ht) {
      var u = s.indexOf(i), l = s[u + 1], g = t(i);
      g === Wo ? a(l, !0) : l && c(function(b) {
        function _() {
          b.isCanceled() || a(l, !0);
        }
        g === !0 ? _() : Promise.resolve(g).then(_);
      });
    }
  }, [e, i]), S.useEffect(function() {
    return function() {
      p();
    };
  }, []), [y, i];
};
function al(e, n, t, r) {
  var o = r.motionEnter, i = o === void 0 ? !0 : o, a = r.motionAppear, d = a === void 0 ? !0 : a, h = r.motionLeave, c = h === void 0 ? !0 : h, p = r.motionDeadline, y = r.motionLeaveImmediately, s = r.onAppearPrepare, u = r.onEnterPrepare, l = r.onLeavePrepare, g = r.onAppearStart, b = r.onEnterStart, _ = r.onLeaveStart, m = r.onAppearActive, f = r.onEnterActive, v = r.onLeaveActive, w = r.onAppearEnd, E = r.onEnterEnd, P = r.onLeaveEnd, T = r.onVisibleChanged, N = Vn(), L = ae(N, 2), R = L[0], Z = L[1], W = Vn(qe), K = ae(W, 2), G = K[0], x = K[1], C = Vn(null), O = ae(C, 2), A = O[0], I = O[1], k = Ge(!1), B = Ge(null);
  function H() {
    return t();
  }
  var X = Ge(!1);
  function V() {
    x(qe, !0), I(null, !0);
  }
  function Y(ie) {
    var re = H();
    if (!(ie && !ie.deadline && ie.target !== re)) {
      var oe = X.current, ee;
      G === Ln && oe ? ee = w == null ? void 0 : w(re, ie) : G === Fn && oe ? ee = E == null ? void 0 : E(re, ie) : G === Rn && oe && (ee = P == null ? void 0 : P(re, ie)), G !== qe && oe && ee !== !1 && V();
    }
  }
  var ce = el(Y), $e = ae(ce, 1), Se = $e[0], pe = function(re) {
    var oe, ee, fe;
    switch (re) {
      case Ln:
        return oe = {}, le(oe, je, s), le(oe, sn, g), le(oe, cn, m), oe;
      case Fn:
        return ee = {}, le(ee, je, u), le(ee, sn, b), le(ee, cn, f), ee;
      case Rn:
        return fe = {}, le(fe, je, l), le(fe, sn, _), le(fe, cn, v), fe;
      default:
        return {};
    }
  }, Le = S.useMemo(function() {
    return pe(G);
  }, [G]), Pe = il(G, !e, function(ie) {
    if (ie === je) {
      var re = Le[je];
      return re ? re(H()) : Wo;
    }
    if (ye in Le) {
      var oe;
      I(((oe = Le[ye]) === null || oe === void 0 ? void 0 : oe.call(Le, H(), null)) || null);
    }
    return ye === cn && (Se(H()), p > 0 && (clearTimeout(B.current), B.current = setTimeout(function() {
      Y({
        deadline: !0
      });
    }, p))), ye === ko && V(), ol;
  }), Ne = ae(Pe, 2), he = Ne[0], ye = Ne[1], Fe = zo(ye);
  X.current = Fe, Do(function() {
    Z(n);
    var ie = k.current;
    k.current = !0;
    var re;
    !ie && n && d && (re = Ln), ie && n && i && (re = Fn), (ie && !n && c || !ie && y && !n && c) && (re = Rn);
    var oe = pe(re);
    re && (e || oe[je]) ? (x(re), he()) : x(qe);
  }, [n]), Je(function() {
    // Cancel appear
    (G === Ln && !d || // Cancel enter
    G === Fn && !i || // Cancel leave
    G === Rn && !c) && x(qe);
  }, [d, i, c]), Je(function() {
    return function() {
      k.current = !1, clearTimeout(B.current);
    };
  }, []);
  var be = S.useRef(!1);
  Je(function() {
    R && (be.current = !0), R !== void 0 && G === qe && ((be.current || R) && (T == null || T(R)), be.current = !0);
  }, [R, G]);
  var Ee = A;
  return Le[je] && ye === sn && (Ee = z({
    transition: "none"
  }, Ee)), [G, ye, Ee, R ?? n];
}
function sl(e) {
  var n = e;
  Oe(e) === "object" && (n = e.transitionSupport);
  function t(o, i) {
    return !!(o.motionName && n && i !== !1);
  }
  var r = /* @__PURE__ */ S.forwardRef(function(o, i) {
    var a = o.visible, d = a === void 0 ? !0 : a, h = o.removeOnLeave, c = h === void 0 ? !0 : h, p = o.forceRender, y = o.children, s = o.motionName, u = o.leavedClassName, l = o.eventProps, g = S.useContext(Yc), b = g.motion, _ = t(o, b), m = Ge(), f = Ge();
    function v() {
      try {
        return m.current instanceof HTMLElement ? m.current : Kc(f.current);
      } catch {
        return null;
      }
    }
    var w = al(_, d, v, o), E = ae(w, 4), P = E[0], T = E[1], N = E[2], L = E[3], R = S.useRef(L);
    L && (R.current = !0);
    var Z = S.useCallback(function(I) {
      m.current = I, Gc(i, I);
    }, [i]), W, K = z(z({}, l), {}, {
      visible: d
    });
    if (!y)
      W = null;
    else if (P === qe)
      L ? W = y(z({}, K), Z) : !c && R.current && u ? W = y(z(z({}, K), {}, {
        className: u
      }), Z) : p || !c && !u ? W = y(z(z({}, K), {}, {
        style: {
          display: "none"
        }
      }), Z) : W = null;
    else {
      var G, x;
      T === je ? x = "prepare" : zo(T) ? x = "active" : T === sn && (x = "start");
      var C = xr(s, "".concat(P, "-").concat(x));
      W = y(z(z({}, K), {}, {
        className: De(xr(s, P), (G = {}, le(G, C, C && x), le(G, s, typeof s == "string"), G)),
        style: N
      }), Z);
    }
    if (/* @__PURE__ */ S.isValidElement(W) && Xc(W)) {
      var O = W, A = O.ref;
      A || (W = /* @__PURE__ */ S.cloneElement(W, {
        ref: Z
      }));
    }
    return /* @__PURE__ */ S.createElement(qc, {
      ref: f
    }, W);
  });
  return r.displayName = "CSSMotion", r;
}
const cl = sl(jo);
var Et = "add", Ct = "keep", xt = "remove", st = "removed";
function ll(e) {
  var n;
  return e && Oe(e) === "object" && "key" in e ? n = e : n = {
    key: e
  }, z(z({}, n), {}, {
    key: String(n.key)
  });
}
function Ot() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return e.map(ll);
}
function ul() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], t = [], r = 0, o = n.length, i = Ot(e), a = Ot(n);
  i.forEach(function(c) {
    for (var p = !1, y = r; y < o; y += 1) {
      var s = a[y];
      if (s.key === c.key) {
        r < y && (t = t.concat(a.slice(r, y).map(function(u) {
          return z(z({}, u), {}, {
            status: Et
          });
        })), r = y), t.push(z(z({}, s), {}, {
          status: Ct
        })), r += 1, p = !0;
        break;
      }
    }
    p || t.push(z(z({}, c), {}, {
      status: xt
    }));
  }), r < o && (t = t.concat(a.slice(r).map(function(c) {
    return z(z({}, c), {}, {
      status: Et
    });
  })));
  var d = {};
  t.forEach(function(c) {
    var p = c.key;
    d[p] = (d[p] || 0) + 1;
  });
  var h = Object.keys(d).filter(function(c) {
    return d[c] > 1;
  });
  return h.forEach(function(c) {
    t = t.filter(function(p) {
      var y = p.key, s = p.status;
      return y !== c || s !== xt;
    }), t.forEach(function(p) {
      p.key === c && (p.status = Ct);
    });
  }), t;
}
var dl = ["component", "children", "onVisibleChanged", "onAllRemoved"], fl = ["status"], ml = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function gl(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : cl, t = /* @__PURE__ */ function(r) {
    Ur(i, r);
    var o = Wr(i);
    function i() {
      var a;
      zr(this, i);
      for (var d = arguments.length, h = new Array(d), c = 0; c < d; c++)
        h[c] = arguments[c];
      return a = o.call.apply(o, [this].concat(h)), le(nr(a), "state", {
        keyEntities: []
      }), le(nr(a), "removeKey", function(p) {
        var y = a.state.keyEntities, s = y.map(function(u) {
          return u.key !== p ? u : z(z({}, u), {}, {
            status: st
          });
        });
        return a.setState({
          keyEntities: s
        }), s.filter(function(u) {
          var l = u.status;
          return l !== st;
        }).length;
      }), a;
    }
    return Br(i, [{
      key: "render",
      value: function() {
        var d = this, h = this.state.keyEntities, c = this.props, p = c.component, y = c.children, s = c.onVisibleChanged, u = c.onAllRemoved, l = un(c, dl), g = p || S.Fragment, b = {};
        return ml.forEach(function(_) {
          b[_] = l[_], delete l[_];
        }), delete l.keys, /* @__PURE__ */ S.createElement(g, l, h.map(function(_, m) {
          var f = _.status, v = un(_, fl), w = f === Et || f === Ct;
          return /* @__PURE__ */ S.createElement(n, ke({}, b, {
            key: v.key,
            visible: w,
            eventProps: v,
            onVisibleChanged: function(P) {
              if (s == null || s(P, {
                key: v.key
              }), !P) {
                var T = d.removeKey(v.key);
                T === 0 && u && u();
              }
            }
          }), function(E, P) {
            return y(z(z({}, E), {}, {
              index: m
            }), P);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(d, h) {
        var c = d.keys, p = h.keyEntities, y = Ot(c), s = ul(p, y);
        return {
          keyEntities: s.filter(function(u) {
            var l = p.find(function(g) {
              var b = g.key;
              return u.key === b;
            });
            return !(l && l.status === st && u.status === xt);
          })
        };
      }
    }]), i;
  }(S.Component);
  return le(t, "defaultProps", {
    component: "div"
  }), t;
}
const vl = gl(jo);
var F = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function(n) {
    var t = n.keyCode;
    if (n.altKey && !n.ctrlKey || n.metaKey || // Function keys don't generate text
    t >= F.F1 && t <= F.F12)
      return !1;
    switch (t) {
      case F.ALT:
      case F.CAPS_LOCK:
      case F.CONTEXT_MENU:
      case F.CTRL:
      case F.DOWN:
      case F.END:
      case F.ESC:
      case F.HOME:
      case F.INSERT:
      case F.LEFT:
      case F.MAC_FF_META:
      case F.META:
      case F.NUMLOCK:
      case F.NUM_CENTER:
      case F.PAGE_DOWN:
      case F.PAGE_UP:
      case F.PAUSE:
      case F.PRINT_SCREEN:
      case F.RIGHT:
      case F.SHIFT:
      case F.UP:
      case F.WIN_KEY:
      case F.WIN_KEY_RIGHT:
        return !1;
      default:
        return !0;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function(n) {
    if (n >= F.ZERO && n <= F.NINE || n >= F.NUM_ZERO && n <= F.NUM_MULTIPLY || n >= F.A && n <= F.Z || window.navigator.userAgent.indexOf("WebKit") !== -1 && n === 0)
      return !0;
    switch (n) {
      case F.SPACE:
      case F.QUESTION_MARK:
      case F.NUM_PLUS:
      case F.NUM_MINUS:
      case F.NUM_PERIOD:
      case F.NUM_DIVISION:
      case F.SEMICOLON:
      case F.DASH:
      case F.EQUALS:
      case F.COMMA:
      case F.PERIOD:
      case F.SLASH:
      case F.APOSTROPHE:
      case F.SINGLE_QUOTE:
      case F.OPEN_SQUARE_BRACKET:
      case F.BACKSLASH:
      case F.CLOSE_SQUARE_BRACKET:
        return !0;
      default:
        return !1;
    }
  }
}, pl = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`, hl = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`, bl = "".concat(pl, " ").concat(hl).split(/[\s\n]+/), yl = "aria-", wl = "data-";
function Tr(e, n) {
  return e.indexOf(n) === 0;
}
function Sl(e) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, t;
  n === !1 ? t = {
    aria: !0,
    data: !0,
    attr: !0
  } : n === !0 ? t = {
    aria: !0
  } : t = z({}, n);
  var r = {};
  return Object.keys(e).forEach(function(o) {
    // Aria
    (t.aria && (o === "role" || Tr(o, yl)) || // Data
    t.data && Tr(o, wl) || // Attr
    t.attr && bl.includes(o)) && (r[o] = e[o]);
  }), r;
}
var Bo = /* @__PURE__ */ S.forwardRef(function(e, n) {
  var t = e.prefixCls, r = e.style, o = e.className, i = e.duration, a = i === void 0 ? 4.5 : i, d = e.showProgress, h = e.pauseOnHover, c = h === void 0 ? !0 : h, p = e.eventKey, y = e.content, s = e.closable, u = e.closeIcon, l = u === void 0 ? "x" : u, g = e.props, b = e.onClick, _ = e.onNoticeClose, m = e.times, f = e.hovering, v = S.useState(!1), w = ae(v, 2), E = w[0], P = w[1], T = S.useState(0), N = ae(T, 2), L = N[0], R = N[1], Z = S.useState(0), W = ae(Z, 2), K = W[0], G = W[1], x = f || E, C = a > 0 && d, O = function() {
    _(p);
  }, A = function(V) {
    (V.key === "Enter" || V.code === "Enter" || V.keyCode === F.ENTER) && O();
  };
  S.useEffect(function() {
    if (!x && a > 0) {
      var X = Date.now() - K, V = setTimeout(function() {
        O();
      }, a * 1e3 - K);
      return function() {
        c && clearTimeout(V), G(Date.now() - X);
      };
    }
  }, [a, x, m]), S.useEffect(function() {
    if (!x && C && (c || K === 0)) {
      var X = performance.now(), V, Y = function ce() {
        cancelAnimationFrame(V), V = requestAnimationFrame(function($e) {
          var Se = $e + K - X, pe = Math.min(Se / (a * 1e3), 1);
          R(pe * 100), pe < 1 && ce();
        });
      };
      return Y(), function() {
        c && cancelAnimationFrame(V);
      };
    }
  }, [a, K, x, C, m]);
  var I = S.useMemo(function() {
    return Oe(s) === "object" && s !== null ? s : s ? {
      closeIcon: l
    } : {};
  }, [s, l]), k = Sl(I, !0), B = 100 - (!L || L < 0 ? 0 : L > 100 ? 100 : L), H = "".concat(t, "-notice");
  return /* @__PURE__ */ S.createElement("div", ke({}, g, {
    ref: n,
    className: De(H, o, le({}, "".concat(H, "-closable"), s)),
    style: r,
    onMouseEnter: function(V) {
      var Y;
      P(!0), g == null || (Y = g.onMouseEnter) === null || Y === void 0 || Y.call(g, V);
    },
    onMouseLeave: function(V) {
      var Y;
      P(!1), g == null || (Y = g.onMouseLeave) === null || Y === void 0 || Y.call(g, V);
    },
    onClick: b
  }), /* @__PURE__ */ S.createElement("div", {
    className: "".concat(H, "-content")
  }, y), s && /* @__PURE__ */ S.createElement("a", ke({
    tabIndex: 0,
    className: "".concat(H, "-close"),
    onKeyDown: A,
    "aria-label": "Close"
  }, k, {
    onClick: function(V) {
      V.preventDefault(), V.stopPropagation(), O();
    }
  }), I.closeIcon), C && /* @__PURE__ */ S.createElement("progress", {
    className: "".concat(H, "-progress"),
    max: "100",
    value: B
  }, B + "%"));
}), Ho = /* @__PURE__ */ ne.createContext({}), El = function(n) {
  var t = n.children, r = n.classNames;
  return /* @__PURE__ */ ne.createElement(Ho.Provider, {
    value: {
      classNames: r
    }
  }, t);
}, Pr = 8, Nr = 3, Mr = 16, Cl = function(n) {
  var t = {
    offset: Pr,
    threshold: Nr,
    gap: Mr
  };
  if (n && Oe(n) === "object") {
    var r, o, i;
    t.offset = (r = n.offset) !== null && r !== void 0 ? r : Pr, t.threshold = (o = n.threshold) !== null && o !== void 0 ? o : Nr, t.gap = (i = n.gap) !== null && i !== void 0 ? i : Mr;
  }
  return [!!n, t];
}, xl = ["className", "style", "classNames", "styles"], Ko = function(n) {
  var t = n.configList, r = n.placement, o = n.prefixCls, i = n.className, a = n.style, d = n.motion, h = n.onAllNoticeRemoved, c = n.onNoticeClose, p = n.stack, y = en(Ho), s = y.classNames, u = Ge({}), l = rr(null), g = ae(l, 2), b = g[0], _ = g[1], m = rr([]), f = ae(m, 2), v = f[0], w = f[1], E = t.map(function(x) {
    return {
      config: x,
      key: String(x.key)
    };
  }), P = Cl(p), T = ae(P, 2), N = T[0], L = T[1], R = L.offset, Z = L.threshold, W = L.gap, K = N && (v.length > 0 || E.length <= Z), G = typeof d == "function" ? d(r) : d;
  return Je(function() {
    N && v.length > 1 && w(function(x) {
      return x.filter(function(C) {
        return E.some(function(O) {
          var A = O.key;
          return C === A;
        });
      });
    });
  }, [v, E, N]), Je(function() {
    var x;
    if (N && u.current[(x = E[E.length - 1]) === null || x === void 0 ? void 0 : x.key]) {
      var C;
      _(u.current[(C = E[E.length - 1]) === null || C === void 0 ? void 0 : C.key]);
    }
  }, [E, N]), /* @__PURE__ */ ne.createElement(vl, ke({
    key: r,
    className: De(o, "".concat(o, "-").concat(r), s == null ? void 0 : s.list, i, le(le({}, "".concat(o, "-stack"), !!N), "".concat(o, "-stack-expanded"), K)),
    style: a,
    keys: E,
    motionAppear: !0
  }, G, {
    onAllRemoved: function() {
      h(r);
    }
  }), function(x, C) {
    var O = x.config, A = x.className, I = x.style, k = x.index, B = O, H = B.key, X = B.times, V = String(H), Y = O, ce = Y.className, $e = Y.style, Se = Y.classNames, pe = Y.styles, Le = un(Y, xl), Pe = E.findIndex(function(Re) {
      return Re.key === V;
    }), Ne = {};
    if (N) {
      var he = E.length - 1 - (Pe > -1 ? Pe : k - 1), ye = r === "top" || r === "bottom" ? "-50%" : "0";
      if (he > 0) {
        var Fe, be, Ee;
        Ne.height = K ? (Fe = u.current[V]) === null || Fe === void 0 ? void 0 : Fe.offsetHeight : b == null ? void 0 : b.offsetHeight;
        for (var ie = 0, re = 0; re < he; re++) {
          var oe;
          ie += ((oe = u.current[E[E.length - 1 - re].key]) === null || oe === void 0 ? void 0 : oe.offsetHeight) + W;
        }
        var ee = (K ? ie : he * R) * (r.startsWith("top") ? 1 : -1), fe = !K && b !== null && b !== void 0 && b.offsetWidth && (be = u.current[V]) !== null && be !== void 0 && be.offsetWidth ? ((b == null ? void 0 : b.offsetWidth) - R * 2 * (he < 3 ? he : 3)) / ((Ee = u.current[V]) === null || Ee === void 0 ? void 0 : Ee.offsetWidth) : 1;
        Ne.transform = "translate3d(".concat(ye, ", ").concat(ee, "px, 0) scaleX(").concat(fe, ")");
      } else
        Ne.transform = "translate3d(".concat(ye, ", 0, 0)");
    }
    return /* @__PURE__ */ ne.createElement("div", {
      ref: C,
      className: De("".concat(o, "-notice-wrapper"), A, Se == null ? void 0 : Se.wrapper),
      style: z(z(z({}, I), Ne), pe == null ? void 0 : pe.wrapper),
      onMouseEnter: function() {
        return w(function($) {
          return $.includes(V) ? $ : [].concat(hn($), [V]);
        });
      },
      onMouseLeave: function() {
        return w(function($) {
          return $.filter(function(q) {
            return q !== V;
          });
        });
      }
    }, /* @__PURE__ */ ne.createElement(Bo, ke({}, Le, {
      ref: function($) {
        Pe > -1 ? u.current[V] = $ : delete u.current[V];
      },
      prefixCls: o,
      classNames: Se,
      styles: pe,
      className: De(ce, s == null ? void 0 : s.notice),
      style: $e,
      times: X,
      key: H,
      eventKey: H,
      onNoticeClose: c,
      hovering: N && v.length > 0
    })));
  });
};
process.env.NODE_ENV !== "production" && (Ko.displayName = "NoticeList");
var Go = /* @__PURE__ */ S.forwardRef(function(e, n) {
  var t = e.prefixCls, r = t === void 0 ? "rc-notification" : t, o = e.container, i = e.motion, a = e.maxCount, d = e.className, h = e.style, c = e.onAllRemoved, p = e.stack, y = e.renderNotifications, s = S.useState([]), u = ae(s, 2), l = u[0], g = u[1], b = function(N) {
    var L, R = l.find(function(Z) {
      return Z.key === N;
    });
    R == null || (L = R.onClose) === null || L === void 0 || L.call(R), g(function(Z) {
      return Z.filter(function(W) {
        return W.key !== N;
      });
    });
  };
  S.useImperativeHandle(n, function() {
    return {
      open: function(N) {
        g(function(L) {
          var R = hn(L), Z = R.findIndex(function(G) {
            return G.key === N.key;
          }), W = z({}, N);
          if (Z >= 0) {
            var K;
            W.times = (((K = L[Z]) === null || K === void 0 ? void 0 : K.times) || 0) + 1, R[Z] = W;
          } else
            W.times = 0, R.push(W);
          return a > 0 && R.length > a && (R = R.slice(-a)), R;
        });
      },
      close: function(N) {
        b(N);
      },
      destroy: function() {
        g([]);
      }
    };
  });
  var _ = S.useState({}), m = ae(_, 2), f = m[0], v = m[1];
  S.useEffect(function() {
    var T = {};
    l.forEach(function(N) {
      var L = N.placement, R = L === void 0 ? "topRight" : L;
      R && (T[R] = T[R] || [], T[R].push(N));
    }), Object.keys(f).forEach(function(N) {
      T[N] = T[N] || [];
    }), v(T);
  }, [l]);
  var w = function(N) {
    v(function(L) {
      var R = z({}, L), Z = R[N] || [];
      return Z.length || delete R[N], R;
    });
  }, E = S.useRef(!1);
  if (S.useEffect(function() {
    Object.keys(f).length > 0 ? E.current = !0 : E.current && (c == null || c(), E.current = !1);
  }, [f]), !o)
    return null;
  var P = Object.keys(f);
  return /* @__PURE__ */ ha.createPortal(/* @__PURE__ */ S.createElement(S.Fragment, null, P.map(function(T) {
    var N = f[T], L = /* @__PURE__ */ S.createElement(Ko, {
      key: T,
      configList: N,
      placement: T,
      prefixCls: r,
      className: d == null ? void 0 : d(T),
      style: h == null ? void 0 : h(T),
      motion: i,
      onNoticeClose: b,
      onAllNoticeRemoved: w,
      stack: p
    });
    return y ? y(L, {
      prefixCls: r,
      key: T
    }) : L;
  })), o);
});
process.env.NODE_ENV !== "production" && (Go.displayName = "Notifications");
var Ol = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"], Tl = function() {
  return document.body;
}, Ar = 0;
function Pl() {
  for (var e = {}, n = arguments.length, t = new Array(n), r = 0; r < n; r++)
    t[r] = arguments[r];
  return t.forEach(function(o) {
    o && Object.keys(o).forEach(function(i) {
      var a = o[i];
      a !== void 0 && (e[i] = a);
    });
  }), e;
}
function Nl() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = e.getContainer, t = n === void 0 ? Tl : n, r = e.motion, o = e.prefixCls, i = e.maxCount, a = e.className, d = e.style, h = e.onAllRemoved, c = e.stack, p = e.renderNotifications, y = un(e, Ol), s = S.useState(), u = ae(s, 2), l = u[0], g = u[1], b = S.useRef(), _ = /* @__PURE__ */ S.createElement(Go, {
    container: l,
    ref: b,
    prefixCls: o,
    motion: r,
    maxCount: i,
    className: a,
    style: d,
    onAllRemoved: h,
    stack: c,
    renderNotifications: p
  }), m = S.useState([]), f = ae(m, 2), v = f[0], w = f[1], E = S.useMemo(function() {
    return {
      open: function(T) {
        var N = Pl(y, T);
        (N.key === null || N.key === void 0) && (N.key = "rc-notification-".concat(Ar), Ar += 1), w(function(L) {
          return [].concat(hn(L), [{
            type: "open",
            config: N
          }]);
        });
      },
      close: function(T) {
        w(function(N) {
          return [].concat(hn(N), [{
            type: "close",
            key: T
          }]);
        });
      },
      destroy: function() {
        w(function(T) {
          return [].concat(hn(T), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  return S.useEffect(function() {
    g(t());
  }), S.useEffect(function() {
    b.current && v.length && (v.forEach(function(P) {
      switch (P.type) {
        case "open":
          b.current.open(P.config);
          break;
        case "close":
          b.current.close(P.key);
          break;
        case "destroy":
          b.current.destroy();
          break;
      }
    }), w(function(P) {
      return P.filter(function(T) {
        return !v.includes(T);
      });
    }));
  }, [v]), [E, _];
}
var Ml = { icon: { tag: "svg", attrs: { viewBox: "0 0 1024 1024", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, name: "loading", theme: "outlined" };
const Al = Ml;
var Il = function(n, t) {
  return /* @__PURE__ */ S.createElement(dn, ke({}, n, {
    ref: t,
    icon: Al
  }));
}, Xo = /* @__PURE__ */ S.forwardRef(Il);
process.env.NODE_ENV !== "production" && (Xo.displayName = "LoadingOutlined");
const kl = Xo, Yo = /* @__PURE__ */ ne.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yo.displayName = "zIndexContext");
const _l = Yo, Qe = 100, Ll = 10, qo = Qe * Ll, Qo = {
  Modal: Qe,
  Drawer: Qe,
  Popover: Qe,
  Popconfirm: Qe,
  Tooltip: Qe,
  Tour: Qe
}, Fl = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function Rl(e) {
  return e in Qo;
}
function Vd(e, n) {
  const [, t] = nn(), r = ne.useContext(_l), o = Rl(e);
  if (n !== void 0)
    return [n, n];
  let i = r ?? 0;
  return o ? (i += // Use preset token zIndex by default but not stack when has parent container
  (r ? 0 : t.zIndexPopupBase) + // Container offset
  Qo[e], i = Math.min(i, t.zIndexPopupBase + qo)) : i += Fl[e], [r === void 0 ? n : i, i];
}
const jl = (e) => {
  const {
    componentCls: n,
    iconCls: t,
    boxShadow: r,
    colorText: o,
    colorSuccess: i,
    colorError: a,
    colorWarning: d,
    colorInfo: h,
    fontSizeLG: c,
    motionEaseInOutCirc: p,
    motionDurationSlow: y,
    marginXS: s,
    paddingXS: u,
    borderRadiusLG: l,
    zIndexPopup: g,
    // Custom token
    contentPadding: b,
    contentBg: _
  } = e, m = `${n}-notice`, f = new tr("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: u,
      transform: "translateY(0)",
      opacity: 1
    }
  }), v = new tr("MessageMoveOut", {
    "0%": {
      maxHeight: e.height,
      padding: u,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  }), w = {
    padding: u,
    textAlign: "center",
    [`${n}-custom-content`]: {
      display: "flex",
      alignItems: "center"
    },
    [`${n}-custom-content > ${t}`]: {
      marginInlineEnd: s,
      // affected by ltr or rtl
      fontSize: c
    },
    [`${m}-content`]: {
      display: "inline-block",
      padding: b,
      background: _,
      borderRadius: l,
      boxShadow: r,
      pointerEvents: "all"
    },
    [`${n}-success > ${t}`]: {
      color: i
    },
    [`${n}-error > ${t}`]: {
      color: a
    },
    [`${n}-warning > ${t}`]: {
      color: d
    },
    [`${n}-info > ${t},
      ${n}-loading > ${t}`]: {
      color: h
    }
  };
  return [
    // ============================ Holder ============================
    {
      [n]: Object.assign(Object.assign({}, Ms(e)), {
        color: o,
        position: "fixed",
        top: s,
        width: "100%",
        pointerEvents: "none",
        zIndex: g,
        [`${n}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${n}-move-up-appear,
        ${n}-move-up-enter
      `]: {
          animationName: f,
          animationDuration: y,
          animationPlayState: "paused",
          animationTimingFunction: p
        },
        [`
        ${n}-move-up-appear${n}-move-up-appear-active,
        ${n}-move-up-enter${n}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${n}-move-up-leave`]: {
          animationName: v,
          animationDuration: y,
          animationPlayState: "paused",
          animationTimingFunction: p
        },
        [`${n}-move-up-leave${n}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [n]: {
        [`${m}-wrapper`]: Object.assign({}, w)
      }
    },
    // ============================= Pure =============================
    {
      [`${n}-notice-pure-panel`]: Object.assign(Object.assign({}, w), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
}, Dl = (e) => ({
  zIndexPopup: e.zIndexPopupBase + qo + 10,
  contentBg: e.colorBgElevated,
  contentPadding: `${(e.controlHeightLG - e.fontSize * e.lineHeight) / 2}px ${e.paddingSM}px`
}), Zo = $s("Message", (e) => {
  const n = Vt(e, {
    height: 150
  });
  return [jl(n)];
}, Dl);
var $l = globalThis && globalThis.__rest || function(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
};
const Vl = {
  info: /* @__PURE__ */ S.createElement(zc, null),
  success: /* @__PURE__ */ S.createElement(Pc, null),
  error: /* @__PURE__ */ S.createElement(Ic, null),
  warning: /* @__PURE__ */ S.createElement($c, null),
  loading: /* @__PURE__ */ S.createElement(kl, null)
}, Jo = (e) => {
  let {
    prefixCls: n,
    type: t,
    icon: r,
    children: o
  } = e;
  return /* @__PURE__ */ S.createElement("div", {
    className: De(`${n}-custom-content`, `${n}-${t}`)
  }, r || Vl[t], /* @__PURE__ */ S.createElement("span", null, o));
}, Ul = (e) => {
  const {
    prefixCls: n,
    className: t,
    type: r,
    icon: o,
    content: i
  } = e, a = $l(e, ["prefixCls", "className", "type", "icon", "content"]), {
    getPrefixCls: d
  } = S.useContext(tn), h = n || d("message"), c = Io(h), [p, y, s] = Zo(h, c);
  return p(/* @__PURE__ */ S.createElement(Bo, Object.assign({}, a, {
    prefixCls: h,
    className: De(t, y, `${h}-notice-pure-panel`, s, c),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ S.createElement(Jo, {
      prefixCls: h,
      type: r,
      icon: o
    }, i)
  })));
}, Wl = Ul;
function zl(e, n) {
  return {
    motionName: n ?? `${e}-move-up`
  };
}
function Gt(e) {
  let n;
  const t = new Promise((o) => {
    n = e(() => {
      o(!0);
    });
  }), r = () => {
    n == null || n();
  };
  return r.then = (o, i) => t.then(o, i), r.promise = t, r;
}
var Bl = globalThis && globalThis.__rest || function(e, n) {
  var t = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
  return t;
};
const Hl = 8, Kl = 3, Gl = (e) => {
  let {
    children: n,
    prefixCls: t
  } = e;
  const r = Io(t), [o, i, a] = Zo(t, r);
  return o(/* @__PURE__ */ S.createElement(El, {
    classNames: {
      list: De(i, a, r)
    }
  }, n));
}, Xl = (e, n) => {
  let {
    prefixCls: t,
    key: r
  } = n;
  return /* @__PURE__ */ S.createElement(Gl, {
    prefixCls: t,
    key: r
  }, e);
}, Yl = /* @__PURE__ */ S.forwardRef((e, n) => {
  const {
    top: t,
    prefixCls: r,
    getContainer: o,
    maxCount: i,
    duration: a = Kl,
    rtl: d,
    transitionName: h,
    onAllRemoved: c
  } = e, {
    getPrefixCls: p,
    getPopupContainer: y,
    message: s,
    direction: u
  } = S.useContext(tn), l = r || p("message"), g = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: t ?? Hl
  }), b = () => De({
    [`${l}-rtl`]: d ?? u === "rtl"
  }), _ = () => zl(l, h), m = /* @__PURE__ */ S.createElement("span", {
    className: `${l}-close-x`
  }, /* @__PURE__ */ S.createElement(Fc, {
    className: `${l}-close-icon`
  })), [f, v] = Nl({
    prefixCls: l,
    style: g,
    className: b,
    motion: _,
    closable: !1,
    closeIcon: m,
    duration: a,
    getContainer: () => (o == null ? void 0 : o()) || (y == null ? void 0 : y()) || document.body,
    maxCount: i,
    onAllRemoved: c,
    renderNotifications: Xl
  });
  return S.useImperativeHandle(n, () => Object.assign(Object.assign({}, f), {
    prefixCls: l,
    message: s
  })), v;
});
let Ir = 0;
function ei(e) {
  const n = S.useRef(null), t = Tn("Message");
  return [S.useMemo(() => {
    const o = (c) => {
      var p;
      (p = n.current) === null || p === void 0 || p.close(c);
    }, i = (c) => {
      if (!n.current) {
        process.env.NODE_ENV !== "production" && t(!1, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.");
        const P = () => {
        };
        return P.then = () => {
        }, P;
      }
      const {
        open: p,
        prefixCls: y,
        message: s
      } = n.current, u = `${y}-notice`, {
        content: l,
        icon: g,
        type: b,
        key: _,
        className: m,
        style: f,
        onClose: v
      } = c, w = Bl(c, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let E = _;
      return E == null && (Ir += 1, E = `antd-message-${Ir}`), Gt((P) => (p(Object.assign(Object.assign({}, w), {
        key: E,
        content: /* @__PURE__ */ S.createElement(Jo, {
          prefixCls: y,
          type: b,
          icon: g
        }, l),
        placement: "top",
        className: De(b && `${u}-${b}`, m, s == null ? void 0 : s.className),
        style: Object.assign(Object.assign({}, s == null ? void 0 : s.style), f),
        onClose: () => {
          v == null || v(), P();
        }
      })), () => {
        o(E);
      }));
    }, d = {
      open: i,
      destroy: (c) => {
        var p;
        c !== void 0 ? o(c) : (p = n.current) === null || p === void 0 || p.destroy();
      }
    };
    return ["info", "success", "warning", "error", "loading"].forEach((c) => {
      const p = (y, s, u) => {
        let l;
        y && typeof y == "object" && "content" in y ? l = y : l = {
          content: y
        };
        let g, b;
        typeof s == "function" ? b = s : (g = s, b = u);
        const _ = Object.assign(Object.assign({
          onClose: b,
          duration: g
        }, l), {
          type: c
        });
        return i(_);
      };
      d[c] = p;
    }), d;
  }, []), /* @__PURE__ */ S.createElement(Yl, Object.assign({
    key: "message-holder"
  }, e, {
    ref: n
  }))];
}
function ql(e) {
  return ei(e);
}
function Cn() {
  Cn = function() {
    return n;
  };
  var e, n = {}, t = Object.prototype, r = t.hasOwnProperty, o = Object.defineProperty || function(x, C, O) {
    x[C] = O.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, a = i.iterator || "@@iterator", d = i.asyncIterator || "@@asyncIterator", h = i.toStringTag || "@@toStringTag";
  function c(x, C, O) {
    return Object.defineProperty(x, C, {
      value: O,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), x[C];
  }
  try {
    c({}, "");
  } catch {
    c = function(O, A, I) {
      return O[A] = I;
    };
  }
  function p(x, C, O, A) {
    var I = C && C.prototype instanceof _ ? C : _, k = Object.create(I.prototype), B = new K(A || []);
    return o(k, "_invoke", {
      value: L(x, O, B)
    }), k;
  }
  function y(x, C, O) {
    try {
      return {
        type: "normal",
        arg: x.call(C, O)
      };
    } catch (A) {
      return {
        type: "throw",
        arg: A
      };
    }
  }
  n.wrap = p;
  var s = "suspendedStart", u = "suspendedYield", l = "executing", g = "completed", b = {};
  function _() {
  }
  function m() {
  }
  function f() {
  }
  var v = {};
  c(v, a, function() {
    return this;
  });
  var w = Object.getPrototypeOf, E = w && w(w(G([])));
  E && E !== t && r.call(E, a) && (v = E);
  var P = f.prototype = _.prototype = Object.create(v);
  function T(x) {
    ["next", "throw", "return"].forEach(function(C) {
      c(x, C, function(O) {
        return this._invoke(C, O);
      });
    });
  }
  function N(x, C) {
    function O(I, k, B, H) {
      var X = y(x[I], x, k);
      if (X.type !== "throw") {
        var V = X.arg, Y = V.value;
        return Y && Oe(Y) == "object" && r.call(Y, "__await") ? C.resolve(Y.__await).then(function(ce) {
          O("next", ce, B, H);
        }, function(ce) {
          O("throw", ce, B, H);
        }) : C.resolve(Y).then(function(ce) {
          V.value = ce, B(V);
        }, function(ce) {
          return O("throw", ce, B, H);
        });
      }
      H(X.arg);
    }
    var A;
    o(this, "_invoke", {
      value: function(k, B) {
        function H() {
          return new C(function(X, V) {
            O(k, B, X, V);
          });
        }
        return A = A ? A.then(H, H) : H();
      }
    });
  }
  function L(x, C, O) {
    var A = s;
    return function(I, k) {
      if (A === l)
        throw Error("Generator is already running");
      if (A === g) {
        if (I === "throw")
          throw k;
        return {
          value: e,
          done: !0
        };
      }
      for (O.method = I, O.arg = k; ; ) {
        var B = O.delegate;
        if (B) {
          var H = R(B, O);
          if (H) {
            if (H === b)
              continue;
            return H;
          }
        }
        if (O.method === "next")
          O.sent = O._sent = O.arg;
        else if (O.method === "throw") {
          if (A === s)
            throw A = g, O.arg;
          O.dispatchException(O.arg);
        } else
          O.method === "return" && O.abrupt("return", O.arg);
        A = l;
        var X = y(x, C, O);
        if (X.type === "normal") {
          if (A = O.done ? g : u, X.arg === b)
            continue;
          return {
            value: X.arg,
            done: O.done
          };
        }
        X.type === "throw" && (A = g, O.method = "throw", O.arg = X.arg);
      }
    };
  }
  function R(x, C) {
    var O = C.method, A = x.iterator[O];
    if (A === e)
      return C.delegate = null, O === "throw" && x.iterator.return && (C.method = "return", C.arg = e, R(x, C), C.method === "throw") || O !== "return" && (C.method = "throw", C.arg = new TypeError("The iterator does not provide a '" + O + "' method")), b;
    var I = y(A, x.iterator, C.arg);
    if (I.type === "throw")
      return C.method = "throw", C.arg = I.arg, C.delegate = null, b;
    var k = I.arg;
    return k ? k.done ? (C[x.resultName] = k.value, C.next = x.nextLoc, C.method !== "return" && (C.method = "next", C.arg = e), C.delegate = null, b) : k : (C.method = "throw", C.arg = new TypeError("iterator result is not an object"), C.delegate = null, b);
  }
  function Z(x) {
    var C = {
      tryLoc: x[0]
    };
    1 in x && (C.catchLoc = x[1]), 2 in x && (C.finallyLoc = x[2], C.afterLoc = x[3]), this.tryEntries.push(C);
  }
  function W(x) {
    var C = x.completion || {};
    C.type = "normal", delete C.arg, x.completion = C;
  }
  function K(x) {
    this.tryEntries = [{
      tryLoc: "root"
    }], x.forEach(Z, this), this.reset(!0);
  }
  function G(x) {
    if (x || x === "") {
      var C = x[a];
      if (C)
        return C.call(x);
      if (typeof x.next == "function")
        return x;
      if (!isNaN(x.length)) {
        var O = -1, A = function I() {
          for (; ++O < x.length; )
            if (r.call(x, O))
              return I.value = x[O], I.done = !1, I;
          return I.value = e, I.done = !0, I;
        };
        return A.next = A;
      }
    }
    throw new TypeError(Oe(x) + " is not iterable");
  }
  return m.prototype = f, o(P, "constructor", {
    value: f,
    configurable: !0
  }), o(f, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = c(f, h, "GeneratorFunction"), n.isGeneratorFunction = function(x) {
    var C = typeof x == "function" && x.constructor;
    return !!C && (C === m || (C.displayName || C.name) === "GeneratorFunction");
  }, n.mark = function(x) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(x, f) : (x.__proto__ = f, c(x, h, "GeneratorFunction")), x.prototype = Object.create(P), x;
  }, n.awrap = function(x) {
    return {
      __await: x
    };
  }, T(N.prototype), c(N.prototype, d, function() {
    return this;
  }), n.AsyncIterator = N, n.async = function(x, C, O, A, I) {
    I === void 0 && (I = Promise);
    var k = new N(p(x, C, O, A), I);
    return n.isGeneratorFunction(C) ? k : k.next().then(function(B) {
      return B.done ? B.value : k.next();
    });
  }, T(P), c(P, h, "Generator"), c(P, a, function() {
    return this;
  }), c(P, "toString", function() {
    return "[object Generator]";
  }), n.keys = function(x) {
    var C = Object(x), O = [];
    for (var A in C)
      O.push(A);
    return O.reverse(), function I() {
      for (; O.length; ) {
        var k = O.pop();
        if (k in C)
          return I.value = k, I.done = !1, I;
      }
      return I.done = !0, I;
    };
  }, n.values = G, K.prototype = {
    constructor: K,
    reset: function(C) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(W), !C)
        for (var O in this)
          O.charAt(0) === "t" && r.call(this, O) && !isNaN(+O.slice(1)) && (this[O] = e);
    },
    stop: function() {
      this.done = !0;
      var C = this.tryEntries[0].completion;
      if (C.type === "throw")
        throw C.arg;
      return this.rval;
    },
    dispatchException: function(C) {
      if (this.done)
        throw C;
      var O = this;
      function A(V, Y) {
        return B.type = "throw", B.arg = C, O.next = V, Y && (O.method = "next", O.arg = e), !!Y;
      }
      for (var I = this.tryEntries.length - 1; I >= 0; --I) {
        var k = this.tryEntries[I], B = k.completion;
        if (k.tryLoc === "root")
          return A("end");
        if (k.tryLoc <= this.prev) {
          var H = r.call(k, "catchLoc"), X = r.call(k, "finallyLoc");
          if (H && X) {
            if (this.prev < k.catchLoc)
              return A(k.catchLoc, !0);
            if (this.prev < k.finallyLoc)
              return A(k.finallyLoc);
          } else if (H) {
            if (this.prev < k.catchLoc)
              return A(k.catchLoc, !0);
          } else {
            if (!X)
              throw Error("try statement without catch or finally");
            if (this.prev < k.finallyLoc)
              return A(k.finallyLoc);
          }
        }
      }
    },
    abrupt: function(C, O) {
      for (var A = this.tryEntries.length - 1; A >= 0; --A) {
        var I = this.tryEntries[A];
        if (I.tryLoc <= this.prev && r.call(I, "finallyLoc") && this.prev < I.finallyLoc) {
          var k = I;
          break;
        }
      }
      k && (C === "break" || C === "continue") && k.tryLoc <= O && O <= k.finallyLoc && (k = null);
      var B = k ? k.completion : {};
      return B.type = C, B.arg = O, k ? (this.method = "next", this.next = k.finallyLoc, b) : this.complete(B);
    },
    complete: function(C, O) {
      if (C.type === "throw")
        throw C.arg;
      return C.type === "break" || C.type === "continue" ? this.next = C.arg : C.type === "return" ? (this.rval = this.arg = C.arg, this.method = "return", this.next = "end") : C.type === "normal" && O && (this.next = O), b;
    },
    finish: function(C) {
      for (var O = this.tryEntries.length - 1; O >= 0; --O) {
        var A = this.tryEntries[O];
        if (A.finallyLoc === C)
          return this.complete(A.completion, A.afterLoc), W(A), b;
      }
    },
    catch: function(C) {
      for (var O = this.tryEntries.length - 1; O >= 0; --O) {
        var A = this.tryEntries[O];
        if (A.tryLoc === C) {
          var I = A.completion;
          if (I.type === "throw") {
            var k = I.arg;
            W(A);
          }
          return k;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function(C, O, A) {
      return this.delegate = {
        iterator: G(C),
        resultName: O,
        nextLoc: A
      }, this.method === "next" && (this.arg = e), b;
    }
  }, n;
}
function kr(e, n, t, r, o, i, a) {
  try {
    var d = e[i](a), h = d.value;
  } catch (c) {
    t(c);
    return;
  }
  d.done ? n(h) : Promise.resolve(h).then(r, o);
}
function ni(e) {
  return function() {
    var n = this, t = arguments;
    return new Promise(function(r, o) {
      var i = e.apply(n, t);
      function a(h) {
        kr(i, r, o, a, d, "next", h);
      }
      function d(h) {
        kr(i, r, o, a, d, "throw", h);
      }
      a(void 0);
    });
  };
}
var Pn = z({}, ba), Ql = Pn.version, Zl = Pn.render, Jl = Pn.unmountComponentAtNode, Jn;
try {
  var eu = Number((Ql || "").split(".")[0]);
  eu >= 18 && (Jn = Pn.createRoot);
} catch {
}
function _r(e) {
  var n = Pn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  n && Oe(n) === "object" && (n.usingClientEntryPoint = e);
}
var Bn = "__rc_react_root__";
function nu(e, n) {
  _r(!0);
  var t = n[Bn] || Jn(n);
  _r(!1), t.render(e), n[Bn] = t;
}
function tu(e, n) {
  Zl(e, n);
}
function ru(e, n) {
  if (Jn) {
    nu(e, n);
    return;
  }
  tu(e, n);
}
function ou(e) {
  return Tt.apply(this, arguments);
}
function Tt() {
  return Tt = ni(/* @__PURE__ */ Cn().mark(function e(n) {
    return Cn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            return r.abrupt("return", Promise.resolve().then(function() {
              var o;
              (o = n[Bn]) === null || o === void 0 || o.unmount(), delete n[Bn];
            }));
          case 1:
          case "end":
            return r.stop();
        }
    }, e);
  })), Tt.apply(this, arguments);
}
function iu(e) {
  Jl(e);
}
function Ud(e) {
  return Pt.apply(this, arguments);
}
function Pt() {
  return Pt = ni(/* @__PURE__ */ Cn().mark(function e(n) {
    return Cn().wrap(function(r) {
      for (; ; )
        switch (r.prev = r.next) {
          case 0:
            if (Jn === void 0) {
              r.next = 2;
              break;
            }
            return r.abrupt("return", ou(n));
          case 2:
            iu(n);
          case 3:
          case "end":
            return r.stop();
        }
    }, e);
  })), Pt.apply(this, arguments);
}
const au = /* @__PURE__ */ ne.createContext({});
let Ie = null, Ze = (e) => e(), xn = [], On = {};
function Lr() {
  const {
    getContainer: e,
    duration: n,
    rtl: t,
    maxCount: r,
    top: o
  } = On, i = (e == null ? void 0 : e()) || document.body;
  return {
    getContainer: () => i,
    duration: n,
    rtl: t,
    maxCount: r,
    top: o
  };
}
const su = /* @__PURE__ */ ne.forwardRef((e, n) => {
  const {
    messageConfig: t,
    sync: r
  } = e, {
    getPrefixCls: o
  } = en(tn), i = On.prefixCls || o("message"), a = en(au), [d, h] = ei(Object.assign(Object.assign(Object.assign({}, t), {
    prefixCls: i
  }), a.message));
  return ne.useImperativeHandle(n, () => {
    const c = Object.assign({}, d);
    return Object.keys(c).forEach((p) => {
      c[p] = function() {
        return r(), d[p].apply(d, arguments);
      };
    }), {
      instance: c,
      sync: r
    };
  }), h;
}), cu = /* @__PURE__ */ ne.forwardRef((e, n) => {
  const [t, r] = ne.useState(Lr), o = () => {
    r(Lr);
  };
  ne.useEffect(o, []);
  const i = bo(), a = i.getRootPrefixCls(), d = i.getIconPrefixCls(), h = i.getTheme(), c = /* @__PURE__ */ ne.createElement(su, {
    ref: n,
    sync: o,
    messageConfig: t
  });
  return /* @__PURE__ */ ne.createElement(rn, {
    prefixCls: a,
    iconPrefixCls: d,
    theme: h
  }, i.holderRender ? i.holderRender(c) : c);
});
function et() {
  if (!Ie) {
    const e = document.createDocumentFragment(), n = {
      fragment: e
    };
    Ie = n, Ze(() => {
      ru(/* @__PURE__ */ ne.createElement(cu, {
        ref: (t) => {
          const {
            instance: r,
            sync: o
          } = t || {};
          Promise.resolve().then(() => {
            !n.instance && r && (n.instance = r, n.sync = o, et());
          });
        }
      }), e);
    });
    return;
  }
  Ie.instance && (xn.forEach((e) => {
    const {
      type: n,
      skipped: t
    } = e;
    if (!t)
      switch (n) {
        case "open": {
          Ze(() => {
            const r = Ie.instance.open(Object.assign(Object.assign({}, On), e.config));
            r == null || r.then(e.resolve), e.setCloseFn(r);
          });
          break;
        }
        case "destroy":
          Ze(() => {
            Ie == null || Ie.instance.destroy(e.key);
          });
          break;
        default:
          Ze(() => {
            var r;
            const o = (r = Ie.instance)[n].apply(r, Ia(e.args));
            o == null || o.then(e.resolve), e.setCloseFn(o);
          });
      }
  }), xn = []);
}
function lu(e) {
  On = Object.assign(Object.assign({}, On), e), Ze(() => {
    var n;
    (n = Ie == null ? void 0 : Ie.sync) === null || n === void 0 || n.call(Ie);
  });
}
function uu(e) {
  const n = Gt((t) => {
    let r;
    const o = {
      type: "open",
      config: e,
      resolve: t,
      setCloseFn: (i) => {
        r = i;
      }
    };
    return xn.push(o), () => {
      r ? Ze(() => {
        r();
      }) : o.skipped = !0;
    };
  });
  return et(), n;
}
function du(e, n) {
  const t = bo();
  process.env.NODE_ENV !== "production" && !t.holderRender && Xs("message");
  const r = Gt((o) => {
    let i;
    const a = {
      type: e,
      args: n,
      resolve: o,
      setCloseFn: (d) => {
        i = d;
      }
    };
    return xn.push(a), () => {
      i ? Ze(() => {
        i();
      }) : a.skipped = !0;
    };
  });
  return et(), r;
}
const fu = (e) => {
  xn.push({
    type: "destroy",
    key: e
  }), et();
}, mu = ["success", "info", "warning", "error", "loading"], gu = {
  open: uu,
  destroy: fu,
  config: lu,
  useMessage: ql,
  _InternalPanelDoNotUseOrYouWillBeFired: Wl
}, ti = gu;
mu.forEach((e) => {
  ti[e] = function() {
    for (var n = arguments.length, t = new Array(n), r = 0; r < n; r++)
      t[r] = arguments[r];
    return du(e, t);
  };
});
process.env.NODE_ENV;
process.env.NODE_ENV;
const Wd = ti;
var M = {}, Nt = { exports: {} };
(function(e, n) {
  (function(t, r) {
    var o = "1.0.37", i = "", a = "?", d = "function", h = "undefined", c = "object", p = "string", y = "major", s = "model", u = "name", l = "type", g = "vendor", b = "version", _ = "architecture", m = "console", f = "mobile", v = "tablet", w = "smarttv", E = "wearable", P = "embedded", T = 500, N = "Amazon", L = "Apple", R = "ASUS", Z = "BlackBerry", W = "Browser", K = "Chrome", G = "Edge", x = "Firefox", C = "Google", O = "Huawei", A = "LG", I = "Microsoft", k = "Motorola", B = "Opera", H = "Samsung", X = "Sharp", V = "Sony", Y = "Xiaomi", ce = "Zebra", $e = "Facebook", Se = "Chromium OS", pe = "Mac OS", Le = function($, q) {
      var U = {};
      for (var J in $)
        q[J] && q[J].length % 2 === 0 ? U[J] = q[J].concat($[J]) : U[J] = $[J];
      return U;
    }, Pe = function($) {
      for (var q = {}, U = 0; U < $.length; U++)
        q[$[U].toUpperCase()] = $[U];
      return q;
    }, Ne = function($, q) {
      return typeof $ === p ? he(q).indexOf(he($)) !== -1 : !1;
    }, he = function($) {
      return $.toLowerCase();
    }, ye = function($) {
      return typeof $ === p ? $.replace(/[^\d\.]/g, i).split(".")[0] : r;
    }, Fe = function($, q) {
      if (typeof $ === p)
        return $ = $.replace(/^\s\s*/, i), typeof q === h ? $ : $.substring(0, T);
    }, be = function($, q) {
      for (var U = 0, J, Ve, Me, Q, j, Ae; U < q.length && !j; ) {
        var mn = q[U], An = q[U + 1];
        for (J = Ve = 0; J < mn.length && !j && mn[J]; )
          if (j = mn[J++].exec($), j)
            for (Me = 0; Me < An.length; Me++)
              Ae = j[++Ve], Q = An[Me], typeof Q === c && Q.length > 0 ? Q.length === 2 ? typeof Q[1] == d ? this[Q[0]] = Q[1].call(this, Ae) : this[Q[0]] = Q[1] : Q.length === 3 ? typeof Q[1] === d && !(Q[1].exec && Q[1].test) ? this[Q[0]] = Ae ? Q[1].call(this, Ae, Q[2]) : r : this[Q[0]] = Ae ? Ae.replace(Q[1], Q[2]) : r : Q.length === 4 && (this[Q[0]] = Ae ? Q[3].call(this, Ae.replace(Q[1], Q[2])) : r) : this[Q] = Ae || r;
        U += 2;
      }
    }, Ee = function($, q) {
      for (var U in q)
        if (typeof q[U] === c && q[U].length > 0) {
          for (var J = 0; J < q[U].length; J++)
            if (Ne(q[U][J], $))
              return U === a ? r : U;
        } else if (Ne(q[U], $))
          return U === a ? r : U;
      return $;
    }, ie = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, re = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, oe = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [b, [u, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [b, [u, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [u, b], [/opios[\/ ]+([\w\.]+)/i], [b, [u, B + " Mini"]], [/\bopr\/([\w\.]+)/i], [b, [u, B]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [b, [u, "Baidu"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i, /(heytap|ovi)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [u, b], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [b, [u, "UC" + W]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [b, [u, "WeChat"]], [/konqueror\/([\w\.]+)/i], [b, [u, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [b, [u, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [b, [u, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [b, [u, "Smart Lenovo " + W]], [/(avast|avg)\/([\w\.]+)/i], [[u, /(.+)/, "$1 Secure " + W], b], [/\bfocus\/([\w\.]+)/i], [b, [u, x + " Focus"]], [/\bopt\/([\w\.]+)/i], [b, [u, B + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [b, [u, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [b, [u, "Dolphin"]], [/coast\/([\w\.]+)/i], [b, [u, B + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [b, [u, "MIUI " + W]], [/fxios\/([-\w\.]+)/i], [b, [u, x]], [/\bqihu|(qi?ho?o?|360)browser/i], [[u, "360 " + W]], [/(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i], [[u, /(.+)/, "$1 " + W], b], [/samsungbrowser\/([\w\.]+)/i], [b, [u, H + " Internet"]], [/(comodo_dragon)\/([\w\.]+)/i], [[u, /_/g, " "], b], [/metasr[\/ ]?([\d\.]+)/i], [b, [u, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[u, "Sogou Mobile"], b], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i], [u, b], [/(lbbrowser)/i, /\[(linkedin)app\]/i], [u], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[u, $e], b], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [u, b], [/\bgsa\/([\w\.]+) .*safari\//i], [b, [u, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [b, [u, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [b, [u, K + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[u, K + " WebView"], b], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [b, [u, "Android " + W]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [u, b], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [b, [u, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [b, u], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [u, [b, Ee, ie]], [/(webkit|khtml)\/([\w\.]+)/i], [u, b], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[u, "Netscape"], b], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [b, [u, x + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i, /panasonic;(viera)/i], [u, b], [/(cobalt)\/([\w\.]+)/i], [u, [b, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[_, "amd64"]], [/(ia32(?=;))/i], [[_, he]], [/((?:i[346]|x)86)[;\)]/i], [[_, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[_, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[_, "armhf"]], [/windows (ce|mobile); ppc;/i], [[_, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[_, /ower/, i, he]], [/(sun4\w)[;\)]/i], [[_, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[_, he]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [s, [g, H], [l, v]], [/\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]([-\w]+)/i, /sec-(sgh\w+)/i], [s, [g, H], [l, f]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [s, [g, L], [l, f]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [s, [g, L], [l, v]], [/(macintosh);/i], [s, [g, L]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [s, [g, X], [l, f]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [s, [g, O], [l, v]], [/(?:huawei|honor)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [s, [g, O], [l, f]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i], [[s, /_/g, " "], [g, Y], [l, f]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[s, /_/g, " "], [g, Y], [l, v]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [s, [g, "OPPO"], [l, f]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [s, [g, "Vivo"], [l, f]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [s, [g, "Realme"], [l, f]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [s, [g, k], [l, f]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [s, [g, k], [l, v]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [s, [g, A], [l, v]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [s, [g, A], [l, f]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [s, [g, "Lenovo"], [l, v]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[s, /_/g, " "], [g, "Nokia"], [l, f]], [/(pixel c)\b/i], [s, [g, C], [l, v]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [s, [g, C], [l, f]], [/droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [s, [g, V], [l, f]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[s, "Xperia Tablet"], [g, V], [l, v]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [s, [g, "OnePlus"], [l, f]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [s, [g, N], [l, v]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[s, /(.+)/g, "Fire Phone $1"], [g, N], [l, f]], [/(playbook);[-\w\),; ]+(rim)/i], [s, g, [l, v]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [s, [g, Z], [l, f]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [s, [g, R], [l, v]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [s, [g, R], [l, f]], [/(nexus 9)/i], [s, [g, "HTC"], [l, v]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [g, [s, /_/g, " "], [l, f]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [s, [g, "Acer"], [l, v]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [s, [g, "Meizu"], [l, f]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [s, [g, "Ulefone"], [l, f]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [g, s, [l, f]], [/(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [g, s, [l, v]], [/(surface duo)/i], [s, [g, I], [l, v]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [s, [g, "Fairphone"], [l, f]], [/(u304aa)/i], [s, [g, "AT&T"], [l, f]], [/\bsie-(\w*)/i], [s, [g, "Siemens"], [l, f]], [/\b(rct\w+) b/i], [s, [g, "RCA"], [l, v]], [/\b(venue[\d ]{2,7}) b/i], [s, [g, "Dell"], [l, v]], [/\b(q(?:mv|ta)\w+) b/i], [s, [g, "Verizon"], [l, v]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [s, [g, "Barnes & Noble"], [l, v]], [/\b(tm\d{3}\w+) b/i], [s, [g, "NuVision"], [l, v]], [/\b(k88) b/i], [s, [g, "ZTE"], [l, v]], [/\b(nx\d{3}j) b/i], [s, [g, "ZTE"], [l, f]], [/\b(gen\d{3}) b.+49h/i], [s, [g, "Swiss"], [l, f]], [/\b(zur\d{3}) b/i], [s, [g, "Swiss"], [l, v]], [/\b((zeki)?tb.*\b) b/i], [s, [g, "Zeki"], [l, v]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[g, "Dragon Touch"], s, [l, v]], [/\b(ns-?\w{0,9}) b/i], [s, [g, "Insignia"], [l, v]], [/\b((nxa|next)-?\w{0,9}) b/i], [s, [g, "NextBook"], [l, v]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[g, "Voice"], s, [l, f]], [/\b(lvtel\-)?(v1[12]) b/i], [[g, "LvTel"], s, [l, f]], [/\b(ph-1) /i], [s, [g, "Essential"], [l, f]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [s, [g, "Envizen"], [l, v]], [/\b(trio[-\w\. ]+) b/i], [s, [g, "MachSpeed"], [l, v]], [/\btu_(1491) b/i], [s, [g, "Rotor"], [l, v]], [/(shield[\w ]+) b/i], [s, [g, "Nvidia"], [l, v]], [/(sprint) (\w+)/i], [g, s, [l, f]], [/(kin\.[onetw]{3})/i], [[s, /\./g, " "], [g, I], [l, f]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [s, [g, ce], [l, v]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [s, [g, ce], [l, f]], [/smart-tv.+(samsung)/i], [g, [l, w]], [/hbbtv.+maple;(\d+)/i], [[s, /^/, "SmartTV"], [g, H], [l, w]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[g, A], [l, w]], [/(apple) ?tv/i], [g, [s, L + " TV"], [l, w]], [/crkey/i], [[s, K + "cast"], [g, C], [l, w]], [/droid.+aft(\w+)( bui|\))/i], [s, [g, N], [l, w]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [s, [g, X], [l, w]], [/(bravia[\w ]+)( bui|\))/i], [s, [g, V], [l, w]], [/(mitv-\w{5}) bui/i], [s, [g, Y], [l, w]], [/Hbbtv.*(technisat) (.*);/i], [g, s, [l, w]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[g, Fe], [s, Fe], [l, w]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[l, w]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [g, s, [l, m]], [/droid.+; (shield) bui/i], [s, [g, "Nvidia"], [l, m]], [/(playstation [345portablevi]+)/i], [s, [g, V], [l, m]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [s, [g, I], [l, m]], [/((pebble))app/i], [g, s, [l, E]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [s, [g, L], [l, E]], [/droid.+; (glass) \d/i], [s, [g, C], [l, E]], [/droid.+; (wt63?0{2,3})\)/i], [s, [g, ce], [l, E]], [/(quest( 2| pro)?)/i], [s, [g, $e], [l, E]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [g, [l, P]], [/(aeobc)\b/i], [s, [g, N], [l, P]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [s, [l, f]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [s, [l, v]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[l, v]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[l, f]], [/(android[-\w\. ]{0,9});.+buil/i], [s, [g, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [b, [u, G + "HTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [b, [u, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [u, b], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [b, u]], os: [[/microsoft (windows) (vista|xp)/i], [u, b], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [u, [b, Ee, re]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[b, Ee, re], [u, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[b, /_/g, "."], [u, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[u, pe], [b, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [b, u], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [u, b], [/\(bb(10);/i], [b, [u, Z]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [b, [u, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [b, [u, x + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [b, [u, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [b, [u, "watchOS"]], [/crkey\/([\d\.]+)/i], [b, [u, K + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[u, Se], b], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [u, b], [/(sunos) ?([\w\.\d]*)/i], [[u, "Solaris"], b], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [u, b]] }, ee = function($, q) {
      if (typeof $ === c && (q = $, $ = r), !(this instanceof ee))
        return new ee($, q).getResult();
      var U = typeof t !== h && t.navigator ? t.navigator : r, J = $ || (U && U.userAgent ? U.userAgent : i), Ve = U && U.userAgentData ? U.userAgentData : r, Me = q ? Le(oe, q) : oe, Q = U && U.userAgent == J;
      return this.getBrowser = function() {
        var j = {};
        return j[u] = r, j[b] = r, be.call(j, J, Me.browser), j[y] = ye(j[b]), Q && U && U.brave && typeof U.brave.isBrave == d && (j[u] = "Brave"), j;
      }, this.getCPU = function() {
        var j = {};
        return j[_] = r, be.call(j, J, Me.cpu), j;
      }, this.getDevice = function() {
        var j = {};
        return j[g] = r, j[s] = r, j[l] = r, be.call(j, J, Me.device), Q && !j[l] && Ve && Ve.mobile && (j[l] = f), Q && j[s] == "Macintosh" && U && typeof U.standalone !== h && U.maxTouchPoints && U.maxTouchPoints > 2 && (j[s] = "iPad", j[l] = v), j;
      }, this.getEngine = function() {
        var j = {};
        return j[u] = r, j[b] = r, be.call(j, J, Me.engine), j;
      }, this.getOS = function() {
        var j = {};
        return j[u] = r, j[b] = r, be.call(j, J, Me.os), Q && !j[u] && Ve && Ve.platform != "Unknown" && (j[u] = Ve.platform.replace(/chrome os/i, Se).replace(/macos/i, pe)), j;
      }, this.getResult = function() {
        return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
      }, this.getUA = function() {
        return J;
      }, this.setUA = function(j) {
        return J = typeof j === p && j.length > T ? Fe(j, T) : j, this;
      }, this.setUA(J), this;
    };
    ee.VERSION = o, ee.BROWSER = Pe([u, b, y]), ee.CPU = Pe([_]), ee.DEVICE = Pe([s, g, l, m, f, w, v, E, P]), ee.ENGINE = ee.OS = Pe([u, b]), e.exports && (n = e.exports = ee), n.UAParser = ee;
    var fe = typeof t !== h && (t.jQuery || t.Zepto);
    if (fe && !fe.ua) {
      var Re = new ee();
      fe.ua = Re.getResult(), fe.ua.get = function() {
        return Re.getUA();
      }, fe.ua.set = function($) {
        Re.setUA($);
        var q = Re.getResult();
        for (var U in q)
          fe.ua[U] = q[U];
      };
    }
  })(typeof window == "object" ? window : ya);
})(Nt, Nt.exports);
var vu = Nt.exports;
Object.defineProperty(M, "__esModule", { value: !0 });
function pu(e) {
  return e && typeof e == "object" && "default" in e ? e.default : e;
}
var ge = ne, te = pu(ge), ri = vu, Xe = new ri(), ve = Xe.getBrowser(), hu = Xe.getCPU(), Te = Xe.getDevice(), Xt = Xe.getEngine(), Ye = Xe.getOS(), Nn = Xe.getUA(), oi = function(n) {
  return Xe.setUA(n);
}, Mn = function(n) {
  if (n) {
    var t = new ri(n);
    return {
      UA: t,
      browser: t.getBrowser(),
      cpu: t.getCPU(),
      device: t.getDevice(),
      engine: t.getEngine(),
      os: t.getOS(),
      ua: t.getUA(),
      setUserAgent: function(o) {
        return t.setUA(o);
      }
    };
  }
}, ii = /* @__PURE__ */ Object.freeze({
  ClientUAInstance: Xe,
  browser: ve,
  cpu: hu,
  device: Te,
  engine: Xt,
  os: Ye,
  ua: Nn,
  setUa: oi,
  parseUserAgent: Mn
});
function Fr(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    n && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function bu(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Fr(Object(t), !0).forEach(function(r) {
      Su(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fr(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function yn(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? yn = function(n) {
    return typeof n;
  } : yn = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, yn(e);
}
function yu(e, n) {
  if (!(e instanceof n))
    throw new TypeError("Cannot call a class as a function");
}
function Rr(e, n) {
  for (var t = 0; t < n.length; t++) {
    var r = n[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function wu(e, n, t) {
  return n && Rr(e.prototype, n), t && Rr(e, t), e;
}
function Su(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
function Mt() {
  return Mt = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, Mt.apply(this, arguments);
}
function Eu(e, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(n && n.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), n && It(e, n);
}
function At(e) {
  return At = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, At(e);
}
function It(e, n) {
  return It = Object.setPrototypeOf || function(r, o) {
    return r.__proto__ = o, r;
  }, It(e, n);
}
function Cu(e, n) {
  if (e == null)
    return {};
  var t = {}, r = Object.keys(e), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(n.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
function _e(e, n) {
  if (e == null)
    return {};
  var t = Cu(e, n), r, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      r = i[o], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (t[r] = e[r]);
  }
  return t;
}
function Un(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function xu(e, n) {
  if (n && (typeof n == "object" || typeof n == "function"))
    return n;
  if (n !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Un(e);
}
function Ou(e, n) {
  return Tu(e) || Pu(e, n) || Nu(e, n) || Mu();
}
function Tu(e) {
  if (Array.isArray(e))
    return e;
}
function Pu(e, n) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r = [], o = !0, i = !1, a, d;
    try {
      for (t = t.call(e); !(o = (a = t.next()).done) && (r.push(a.value), !(n && r.length === n)); o = !0)
        ;
    } catch (h) {
      i = !0, d = h;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i)
          throw d;
      }
    }
    return r;
  }
}
function Nu(e, n) {
  if (e) {
    if (typeof e == "string")
      return jr(e, n);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set")
      return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t))
      return jr(e, n);
  }
}
function jr(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var t = 0, r = new Array(n); t < n; t++)
    r[t] = e[t];
  return r;
}
function Mu() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var me = {
  Mobile: "mobile",
  Tablet: "tablet",
  SmartTv: "smarttv",
  Console: "console",
  Wearable: "wearable",
  Embedded: "embedded",
  Browser: void 0
}, we = {
  Chrome: "Chrome",
  Firefox: "Firefox",
  Opera: "Opera",
  Yandex: "Yandex",
  Safari: "Safari",
  InternetExplorer: "Internet Explorer",
  Edge: "Edge",
  Chromium: "Chromium",
  Ie: "IE",
  MobileSafari: "Mobile Safari",
  EdgeChromium: "Edge Chromium",
  MIUI: "MIUI Browser",
  SamsungBrowser: "Samsung Browser"
}, fn = {
  IOS: "iOS",
  Android: "Android",
  WindowsPhone: "Windows Phone",
  Windows: "Windows",
  MAC_OS: "Mac OS"
}, Au = {
  isMobile: !1,
  isTablet: !1,
  isBrowser: !1,
  isSmartTV: !1,
  isConsole: !1,
  isWearable: !1
}, Iu = function(n) {
  switch (n) {
    case me.Mobile:
      return {
        isMobile: !0
      };
    case me.Tablet:
      return {
        isTablet: !0
      };
    case me.SmartTv:
      return {
        isSmartTV: !0
      };
    case me.Console:
      return {
        isConsole: !0
      };
    case me.Wearable:
      return {
        isWearable: !0
      };
    case me.Browser:
      return {
        isBrowser: !0
      };
    case me.Embedded:
      return {
        isEmbedded: !0
      };
    default:
      return Au;
  }
}, ku = function(n) {
  return oi(n);
}, D = function(n) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
  return n || t;
}, Yt = function() {
  return typeof window < "u" && (window.navigator || navigator) ? window.navigator || navigator : !1;
}, qt = function(n) {
  var t = Yt();
  return t && t.platform && (t.platform.indexOf(n) !== -1 || t.platform === "MacIntel" && t.maxTouchPoints > 1 && !window.MSStream);
}, _u = function(n, t, r, o, i) {
  return {
    isBrowser: n,
    browserMajorVersion: D(t.major),
    browserFullVersion: D(t.version),
    browserName: D(t.name),
    engineName: D(r.name),
    engineVersion: D(r.version),
    osName: D(o.name),
    osVersion: D(o.version),
    userAgent: D(i)
  };
}, Dr = function(n, t, r, o) {
  return bu({}, n, {
    vendor: D(t.vendor),
    model: D(t.model),
    os: D(r.name),
    osVersion: D(r.version),
    ua: D(o)
  });
}, Lu = function(n, t, r, o) {
  return {
    isSmartTV: n,
    engineName: D(t.name),
    engineVersion: D(t.version),
    osName: D(r.name),
    osVersion: D(r.version),
    userAgent: D(o)
  };
}, Fu = function(n, t, r, o) {
  return {
    isConsole: n,
    engineName: D(t.name),
    engineVersion: D(t.version),
    osName: D(r.name),
    osVersion: D(r.version),
    userAgent: D(o)
  };
}, Ru = function(n, t, r, o) {
  return {
    isWearable: n,
    engineName: D(t.name),
    engineVersion: D(t.version),
    osName: D(r.name),
    osVersion: D(r.version),
    userAgent: D(o)
  };
}, ju = function(n, t, r, o, i) {
  return {
    isEmbedded: n,
    vendor: D(t.vendor),
    model: D(t.model),
    engineName: D(r.name),
    engineVersion: D(r.version),
    osName: D(o.name),
    osVersion: D(o.version),
    userAgent: D(i)
  };
};
function Du(e) {
  var n = e ? Mn(e) : ii, t = n.device, r = n.browser, o = n.engine, i = n.os, a = n.ua, d = Iu(t.type), h = d.isBrowser, c = d.isMobile, p = d.isTablet, y = d.isSmartTV, s = d.isConsole, u = d.isWearable, l = d.isEmbedded;
  if (h)
    return _u(h, r, o, i, a);
  if (y)
    return Lu(y, o, i, a);
  if (s)
    return Fu(s, o, i, a);
  if (c || p)
    return Dr(d, t, i, a);
  if (u)
    return Ru(u, o, i, a);
  if (l)
    return ju(l, t, o, i, a);
}
var ai = function(n) {
  var t = n.type;
  return t === me.Mobile;
}, si = function(n) {
  var t = n.type;
  return t === me.Tablet;
}, ci = function(n) {
  var t = n.type;
  return t === me.Mobile || t === me.Tablet;
}, li = function(n) {
  var t = n.type;
  return t === me.SmartTv;
}, Hn = function(n) {
  var t = n.type;
  return t === me.Browser;
}, ui = function(n) {
  var t = n.type;
  return t === me.Wearable;
}, di = function(n) {
  var t = n.type;
  return t === me.Console;
}, fi = function(n) {
  var t = n.type;
  return t === me.Embedded;
}, mi = function(n) {
  var t = n.vendor;
  return D(t);
}, gi = function(n) {
  var t = n.model;
  return D(t);
}, vi = function(n) {
  var t = n.type;
  return D(t, "browser");
}, pi = function(n) {
  var t = n.name;
  return t === fn.Android;
}, hi = function(n) {
  var t = n.name;
  return t === fn.Windows;
}, bi = function(n) {
  var t = n.name;
  return t === fn.MAC_OS;
}, yi = function(n) {
  var t = n.name;
  return t === fn.WindowsPhone;
}, wi = function(n) {
  var t = n.name;
  return t === fn.IOS;
}, Si = function(n) {
  var t = n.version;
  return D(t);
}, Ei = function(n) {
  var t = n.name;
  return D(t);
}, Ci = function(n) {
  var t = n.name;
  return t === we.Chrome;
}, xi = function(n) {
  var t = n.name;
  return t === we.Firefox;
}, Oi = function(n) {
  var t = n.name;
  return t === we.Chromium;
}, Kn = function(n) {
  var t = n.name;
  return t === we.Edge;
}, Ti = function(n) {
  var t = n.name;
  return t === we.Yandex;
}, Pi = function(n) {
  var t = n.name;
  return t === we.Safari || t === we.MobileSafari;
}, Ni = function(n) {
  var t = n.name;
  return t === we.MobileSafari;
}, Mi = function(n) {
  var t = n.name;
  return t === we.Opera;
}, Ai = function(n) {
  var t = n.name;
  return t === we.InternetExplorer || t === we.Ie;
}, Ii = function(n) {
  var t = n.name;
  return t === we.MIUI;
}, ki = function(n) {
  var t = n.name;
  return t === we.SamsungBrowser;
}, _i = function(n) {
  var t = n.version;
  return D(t);
}, Li = function(n) {
  var t = n.major;
  return D(t);
}, Fi = function(n) {
  var t = n.name;
  return D(t);
}, Ri = function(n) {
  var t = n.name;
  return D(t);
}, ji = function(n) {
  var t = n.version;
  return D(t);
}, Di = function() {
  var n = Yt(), t = n && n.userAgent && n.userAgent.toLowerCase();
  return typeof t == "string" ? /electron/.test(t) : !1;
}, ln = function(n) {
  return typeof n == "string" && n.indexOf("Edg/") !== -1;
}, $i = function() {
  var n = Yt();
  return n && (/iPad|iPhone|iPod/.test(n.platform) || n.platform === "MacIntel" && n.maxTouchPoints > 1) && !window.MSStream;
}, ze = function() {
  return qt("iPad");
}, Vi = function() {
  return qt("iPhone");
}, Ui = function() {
  return qt("iPod");
}, Wi = function(n) {
  return D(n);
};
function zi(e) {
  var n = e || ii, t = n.device, r = n.browser, o = n.os, i = n.engine, a = n.ua;
  return {
    isSmartTV: li(t),
    isConsole: di(t),
    isWearable: ui(t),
    isEmbedded: fi(t),
    isMobileSafari: Ni(r) || ze(),
    isChromium: Oi(r),
    isMobile: ci(t) || ze(),
    isMobileOnly: ai(t),
    isTablet: si(t) || ze(),
    isBrowser: Hn(t),
    isDesktop: Hn(t),
    isAndroid: pi(o),
    isWinPhone: yi(o),
    isIOS: wi(o) || ze(),
    isChrome: Ci(r),
    isFirefox: xi(r),
    isSafari: Pi(r),
    isOpera: Mi(r),
    isIE: Ai(r),
    osVersion: Si(o),
    osName: Ei(o),
    fullBrowserVersion: _i(r),
    browserVersion: Li(r),
    browserName: Fi(r),
    mobileVendor: mi(t),
    mobileModel: gi(t),
    engineName: Ri(i),
    engineVersion: ji(i),
    getUA: Wi(a),
    isEdge: Kn(r) || ln(a),
    isYandex: Ti(r),
    deviceType: vi(t),
    isIOS13: $i(),
    isIPad13: ze(),
    isIPhone13: Vi(),
    isIPod13: Ui(),
    isElectron: Di(),
    isEdgeChromium: ln(a),
    isLegacyEdge: Kn(r) && !ln(a),
    isWindows: hi(o),
    isMacOs: bi(o),
    isMIUI: Ii(r),
    isSamsungBrowser: ki(r)
  };
}
var Bi = li(Te), Hi = di(Te), Ki = ui(Te), $u = fi(Te), Vu = Ni(ve) || ze(), Uu = Oi(ve), nt = ci(Te) || ze(), Gi = ai(Te), Xi = si(Te) || ze(), Yi = Hn(Te), Wu = Hn(Te), qi = pi(Ye), Qi = yi(Ye), Zi = wi(Ye) || ze(), zu = Ci(ve), Bu = xi(ve), Hu = Pi(ve), Ku = Mi(ve), Ji = Ai(ve), Gu = Si(Ye), Xu = Ei(Ye), Yu = _i(ve), qu = Li(ve), Qu = Fi(ve), Zu = mi(Te), Ju = gi(Te), ed = Ri(Xt), nd = ji(Xt), td = Wi(Nn), rd = Kn(ve) || ln(Nn), od = Ti(ve), id = vi(Te), ad = $i(), sd = ze(), cd = Vi(), ld = Ui(), ud = Di(), dd = ln(Nn), fd = Kn(ve) && !ln(Nn), md = hi(Ye), gd = bi(Ye), vd = Ii(ve), pd = ki(ve), hd = function(n) {
  if (!(!n || typeof n != "string")) {
    var t = Mn(n), r = t.device, o = t.browser, i = t.os, a = t.engine, d = t.ua;
    return zi({
      device: r,
      browser: o,
      os: i,
      engine: a,
      ua: d
    });
  }
}, bd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return qi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, yd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Yi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, wd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Ji ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Sd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Zi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Ed = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return nt ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Cd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Xi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, xd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Qi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Od = function(n) {
  var t = n.renderWithFragment, r = n.children;
  n.viewClassName, n.style;
  var o = _e(n, ["renderWithFragment", "children", "viewClassName", "style"]);
  return Gi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Td = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Bi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Pd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Hi ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Nd = function(n) {
  var t = n.renderWithFragment, r = n.children, o = _e(n, ["renderWithFragment", "children"]);
  return Ki ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", o, r) : null;
}, Md = function(n) {
  var t = n.renderWithFragment, r = n.children;
  n.viewClassName, n.style;
  var o = n.condition, i = _e(n, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
  return o ? t ? te.createElement(ge.Fragment, null, r) : te.createElement("div", i, r) : null;
};
function Ad(e) {
  return /* @__PURE__ */ function(n) {
    Eu(t, n);
    function t(r) {
      var o;
      return yu(this, t), o = xu(this, At(t).call(this, r)), o.isEventListenerAdded = !1, o.handleOrientationChange = o.handleOrientationChange.bind(Un(o)), o.onOrientationChange = o.onOrientationChange.bind(Un(o)), o.onPageLoad = o.onPageLoad.bind(Un(o)), o.state = {
        isLandscape: !1,
        isPortrait: !1
      }, o;
    }
    return wu(t, [{
      key: "handleOrientationChange",
      value: function() {
        this.isEventListenerAdded || (this.isEventListenerAdded = !0);
        var o = window.innerWidth > window.innerHeight ? 90 : 0;
        this.setState({
          isPortrait: o === 0,
          isLandscape: o === 90
        });
      }
    }, {
      key: "onOrientationChange",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "onPageLoad",
      value: function() {
        this.handleOrientationChange();
      }
    }, {
      key: "componentDidMount",
      value: function() {
        (typeof window > "u" ? "undefined" : yn(window)) !== void 0 && nt && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        window.removeEventListener("resize", this.onOrientationChange, !1);
      }
    }, {
      key: "render",
      value: function() {
        return te.createElement(e, Mt({}, this.props, {
          isLandscape: this.state.isLandscape,
          isPortrait: this.state.isPortrait
        }));
      }
    }]), t;
  }(te.Component);
}
function Id() {
  var e = ge.useState(function() {
    var i = window.innerWidth > window.innerHeight ? 90 : 0;
    return {
      isPortrait: i === 0,
      isLandscape: i === 90,
      orientation: i === 0 ? "portrait" : "landscape"
    };
  }), n = Ou(e, 2), t = n[0], r = n[1], o = ge.useCallback(function() {
    var i = window.innerWidth > window.innerHeight ? 90 : 0, a = {
      isPortrait: i === 0,
      isLandscape: i === 90,
      orientation: i === 0 ? "portrait" : "landscape"
    };
    t.orientation !== a.orientation && r(a);
  }, [t.orientation]);
  return ge.useEffect(function() {
    return (typeof window > "u" ? "undefined" : yn(window)) !== void 0 && nt && (o(), window.addEventListener("load", o, !1), window.addEventListener("resize", o, !1)), function() {
      window.removeEventListener("resize", o, !1), window.removeEventListener("load", o, !1);
    };
  }, [o]), t;
}
function ea(e) {
  var n = e || window.navigator.userAgent;
  return Mn(n);
}
function kd(e) {
  var n = e || window.navigator.userAgent, t = ea(n), r = zi(t);
  return [r, t];
}
M.AndroidView = bd;
M.BrowserTypes = we;
M.BrowserView = yd;
M.ConsoleView = Pd;
M.CustomView = Md;
M.IEView = wd;
M.IOSView = Sd;
M.MobileOnlyView = Od;
M.MobileView = Ed;
M.OsTypes = fn;
M.SmartTVView = Td;
M.TabletView = Cd;
M.WearableView = Nd;
M.WinPhoneView = xd;
M.browserName = Qu;
M.browserVersion = qu;
M.deviceDetect = Du;
M.deviceType = id;
M.engineName = ed;
M.engineVersion = nd;
M.fullBrowserVersion = Yu;
M.getSelectorsByUserAgent = hd;
M.getUA = td;
M.isAndroid = qi;
M.isBrowser = Yi;
M.isChrome = zu;
M.isChromium = Uu;
M.isConsole = Hi;
M.isDesktop = Wu;
M.isEdge = rd;
M.isEdgeChromium = dd;
M.isElectron = ud;
M.isEmbedded = $u;
M.isFirefox = Bu;
M.isIE = Ji;
M.isIOS = Zi;
M.isIOS13 = ad;
M.isIPad13 = sd;
M.isIPhone13 = cd;
M.isIPod13 = ld;
M.isLegacyEdge = fd;
M.isMIUI = vd;
M.isMacOs = gd;
var zd = M.isMobile = nt;
M.isMobileOnly = Gi;
M.isMobileSafari = Vu;
M.isOpera = Ku;
M.isSafari = Hu;
M.isSamsungBrowser = pd;
M.isSmartTV = Bi;
M.isTablet = Xi;
M.isWearable = Ki;
M.isWinPhone = Qi;
M.isWindows = md;
M.isYandex = od;
M.mobileModel = Ju;
M.mobileVendor = Zu;
M.osName = Xu;
M.osVersion = Gu;
M.parseUserAgent = Mn;
M.setUserAgent = ku;
M.useDeviceData = ea;
M.useDeviceSelectors = kd;
M.useMobileOrientation = Id;
M.withOrientationChange = Ad;
export {
  dn as A,
  $d as B,
  rn as C,
  vs as D,
  qo as E,
  Fc as F,
  Pc as G,
  $c as H,
  zc as I,
  Nl as J,
  El as K,
  kl as L,
  Xs as M,
  Bo as N,
  bo as O,
  au as P,
  $t as S,
  ni as _,
  tn as a,
  cl as b,
  $s as c,
  jd as d,
  As as e,
  Tn as f,
  _s as g,
  Io as h,
  zd as i,
  Dd as j,
  nn as k,
  Wd as l,
  Vt as m,
  Cn as n,
  Ic as o,
  Ia as p,
  Fd as q,
  Ms as r,
  mo as s,
  Rd as t,
  Vd as u,
  qs as v,
  ru as w,
  Ud as x,
  qa as y,
  _l as z
};
//# sourceMappingURL=lib-b7ffbdee.js.map
